import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import {Checkbox} from 'primereact/checkbox';
import { Panel } from 'primereact/panel';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import {DataTable} from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import {MultiSelect} from 'primereact/multiselect';
import {Column} from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG, CALENDAR_CONFIG,} from '../../shared/Config';
import { REDIRECT_TO_URL,} from '../../shared/utility';
import {Calendar} from 'primereact/calendar';
import axios from '../../axios-url';
import Messages from '../../shared/UI/Messages/Messages';
import {Button} from 'primereact/button';
import { Toast } from 'primereact/toast';
import moment from 'moment';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import ChendhurLogo from '../../assets/images/Chenthoor_landscape_Logo-removebg-preview.png';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


   class ReportsSetting extends Component {
    state = {
        type:'add',
        userID: 'u123456',
        displayBlockScroll: false,
        stageField: [],
        index: 0,
        basicFilterIndex: 0,
        reportName: '',
        reportType: [],
        reportTypeOptions: [
            {name: 'Tabular Report', value: 1},
            {name: 'Summary Report', value: 2},
        ],
        indexOfCurrentSelectedFilter: '',
        selectedFile: null,
        operators: [],
        filters: [],
        basicAddedFilters: [],
        basicFilters: [],
        advancedFilters: [],
        currentSelectedFilter: null,
        operatorType: false,
        reportRows: false,
        reportHeaders: false,
        reportGeneratedOn: null,
        reportGlobalSearchTerm: '',
        reportSearchColumn: null,
        reportColumnSearchValue: '',
        basicInclusiveOrExclusive: 'inclusive',
        inclusiveOrExclusive: 'inclusive',
        inclusiveOrExclusiveOptions: [
            {label: 'Inclusive', value: 'inclusive'},
            {label: 'Exclusive', value: 'exclusive'},
        ],
        basicNesting: 'N/A',
        nesting: 'N/A',
        nestingOptions: [
            {label: 'Open Nest', value: 'openNest'},
            {label: 'Close Nest', value: 'closeNest'},
            {label: 'Not Applicable', value: 'N/A'},
        ],
        basicConditionCombiner: 'and',
        conditionCombiner: 'and',
        conditionCombinerOptions: [
            {label: 'AND', value: 'and'},
            {label: 'OR', value: 'or'},
            {label: 'Not Applicable', value: 'N/A'},
        ],
        processOptions: [],
        loading: false,
        from: null,
        to: null,
        multiSelect: null,
        multiSelectOptions: [],
        basicMultiSelectOptions: [],
        bitOptions: [
            {label: 'True', value: true},
            {label: 'False', value: false},
        ],
        error: false,
        processValue: false,
        selectedFilters: [],
        availableSummaryColumn: [],
        displaySummaryColumns: [],
        displaySummaryColumns: [],
        groupByColumnValues: [],
        groupByColumnNames: [],
        startedEditingBasicFilter: false,
        startedEditingAdvanceFilter: false,
        orderBy:[],
        selectedOrderBy:[],
        orderByColumn:[],
        orderBySequence:[],
        orderBySequenceOption:[
            {label: '1', value: 1},
            {label: '2', value: 2},
            {label: '3', value: 3},
            {label: '4', value: 4},
            {label: '5', value: 5},
            {label: '6', value: 6},
            {label: '7', value: 7},
            {label: '8', value: 8},
            {label: '9', value: 9},
            {label: '10',value: 10},
        ],
        isMasterReport: false,
        dummyDate: "06/18/2022",
        dummyMultiSelectValue: [],
    }

    //----------------common-functions-start---------------------

    renderHeader = (text) => {
        return (
            <div>
                {text || ''}
                <div className="p-datatable-globalfilter-container">
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search" />
                </div>
            </div>
        );
    }

    reportOperatorLabels = {
        '=': 'Equal To',
        '!=': 'Not Equal To',
        '>': 'Greater Than',
        '>=': 'Greater Than or Equal To',
        '<': 'Lesser Than',
        '<=': 'Lesser Than or Equal To',
        'contains': 'Contains',
        'in': 'In',
    }

    getOperatorLabel = (code) => {
        return this.reportOperatorLabels[code] || code || '';
    }

    getReportAppliedConditionsSummary = () => {
        let allFilters = [...(this.state.basicAddedFilters || []), ...(this.state.filters || [])];
        if(allFilters.length === 0){
            return 'None';
        }
        return allFilters.map((filter, index) => {
            let segment = `${filter.columnName || ''} ${this.getOperatorLabel(filter.operator)} ${(filter.label != null && filter.label !== '') ? filter.label : filter.value}`;
            return index === 0 ? segment : `${(filter.logicalOperator || 'and').toUpperCase()} ${segment}`;
        }).join('  ');
    }

    getReportSearchAppliedSummary = () => {
        let segments = [];
        if(this.state.reportGlobalSearchTerm){
            segments.push(`Global keyword "${this.state.reportGlobalSearchTerm}"`);
        }
        if(this.state.reportSearchColumn && this.state.reportColumnSearchValue){
            segments.push(`${this.state.reportSearchColumn} contains "${this.state.reportColumnSearchValue}"`);
        }
        return segments.length === 0 ? 'None' : segments.join('  ');
    }

    evaluateReportFilterCondition = (cellValue, operator, filterValue) => {
        let cell = cellValue == null ? '' : String(cellValue).trim().toLowerCase();
        let rawValues = Array.isArray(filterValue) ? filterValue : String(filterValue == null ? '' : filterValue).split(',');
        let values = rawValues.map(value => String(value).trim().toLowerCase()).filter(value => value !== '');
        let singleValue = values[0] || '';
        let numCell = parseFloat(cellValue);
        let numValue = parseFloat(singleValue);
        switch(operator){
            case '=': return cell === singleValue;
            case '!=': return cell !== singleValue;
            case 'contains': return cell.includes(singleValue);
            case 'in': return values.some(value => value === cell || cell.includes(value));
            case '>': return !isNaN(numCell) && !isNaN(numValue) && numCell > numValue;
            case '>=': return !isNaN(numCell) && !isNaN(numValue) && numCell >= numValue;
            case '<': return !isNaN(numCell) && !isNaN(numValue) && numCell < numValue;
            case '<=': return !isNaN(numCell) && !isNaN(numValue) && numCell <= numValue;
            default: return true;
        }
    }

    resolveReportRowColumnKey = (row, condition) => {
        if(!row){
            return null;
        }
        let keys = Object.keys(row);
        let candidates = [condition.columnName, condition.column].filter(candidate => candidate != null).map(String);
        for(let candidate of candidates){
            if(Object.prototype.hasOwnProperty.call(row, candidate)){
                return candidate;
            }
            let normalizedCandidate = candidate.toLowerCase().replace(/[^a-z0-9]/g, '');
            let match = keys.find(key => key.toLowerCase().replace(/[^a-z0-9]/g, '') === normalizedCandidate);
            if(match){
                return match;
            }
        }
        return null;
    }

    applyReportFilterConditions = (rows) => {
        let conditions = [...(this.state.basicAddedFilters || []), ...(this.state.filters || [])];
        if(conditions.length === 0){
            return rows;
        }
        return rows.filter(row => {
            let result = true;
            conditions.forEach((condition, index) => {
                let key = this.resolveReportRowColumnKey(row, condition);
                let compareValue = (condition.label != null && condition.label !== '') ? condition.label : condition.value;
                let matches = key ? this.evaluateReportFilterCondition(row[key], condition.operator, compareValue) : true;
                if(index === 0){
                    result = matches;
                } else if(condition.logicalOperator === 'or'){
                    result = result || matches;
                } else {
                    result = result && matches;
                }
            });
            return result;
        });
    }

    applyReportQuickSearch = (rows) => {
        let globalTerm = (this.state.reportGlobalSearchTerm || '').trim().toLowerCase();
        let column = this.state.reportSearchColumn;
        let columnTerm = (this.state.reportColumnSearchValue || '').trim().toLowerCase();

        if(!globalTerm && !(column && columnTerm)){
            return rows;
        }

        return rows.filter(row => {
            if(globalTerm){
                let matchesGlobal = Object.values(row).some(value => String(value == null ? '' : value).toLowerCase().includes(globalTerm));
                if(!matchesGlobal){
                    return false;
                }
            }
            if(column && columnTerm){
                let cellValue = row[column];
                if(!String(cellValue == null ? '' : cellValue).toLowerCase().includes(columnTerm)){
                    return false;
                }
            }
            return true;
        });
    }

    basicActionTemplate = (rowData) => {
        return <div className="actionCenter">
                {/* <Button onClick={() => this.handleEditItem(rowData,'edit','basic')}  type="button" icon="pi pi-pencil" className="p-button-info" ></Button> */}
                <Button onClick={() => this.handleDeleteItem(rowData.dummyId, 'basic')} type="button" icon="pi pi-trash"  className="p-button-danger"/>
            </div>;
    }

    advancedActionTemplate = (rowData) => {
        return <div className="actionCenter">
                {/* <Button onClick={() => this.handleEditItem(rowData,'edit','advanced')}  type="button" icon="pi pi-pencil" className="p-button-info" ></Button> */}
                <Button onClick={() => this.handleDeleteItem(rowData.dummyId, 'advanced')} type="button" icon="pi pi-trash"  className="p-button-danger"/>
            </div>;
    }

    orderByActionTemplate = (rowData) => {
        return <div className="actionCenter">
                <Button onClick={() => this.handleDeleteOrderByItem(rowData.columnValue, )} type="button" icon="pi pi-trash"  className="p-button-danger"/>
            </div>;
    }

    renderColumn = (rowData) => {
        if(rowData && rowData.column){
            let id = rowData.column;
            let selectedColumn = this.state.stageFieldCopy && this.state.stageFieldCopy.filter((el) => el.stageFieldID == id);
            let fieldDescription = selectedColumn && selectedColumn[0].fieldDescription;
            return fieldDescription
        } else {
            return ''
        }
        
    }


    handleTableOperatorChange = (rowData, e) => {
        e.preventDefault();
        if(!e.value){
            this.growl.show({ severity: 'error', summary: null, detail: 'Operator Must be present for reports to work' });
            return;
        }

        let filterType = rowData.filterType;
        let dummyId = rowData.dummyId;
        let value = e.value;
        

        if(filterType == "basic"){
            let updateBasicFilters = this.state.basicAddedFilters.map((el) => {
                if(el.dummyId == dummyId){
                return {...el, operator: value}
                } else return el
            })
            this.setState({basicAddedFilters: updateBasicFilters})
              
             
        } else {
            let updateAdvancedFilters = this.state.filters.map((el) => {
                if(el.dummyId == dummyId){
                return {...el, operator: value}
                } else return el
            })
            this.setState({filters: updateAdvancedFilters})
        }
        
    }

    handleTableValueChange = (rowData, e) => {
        // e.preventDefault();
        // console.log({e, rowData})

        let filterType = rowData.filterType;
        let dummyId = rowData.dummyId;
        let value = e.target.value;

        if(rowData.columnType == 'date'){
            value =  moment(value).format('MM/DD/YYYY')
        }

        if(filterType == "basic"){
            let updateBasicFilters = this.state.basicAddedFilters.map((el) => {
                if(el.dummyId == dummyId){
                return {...el, value}
                } else return el
            })
            this.setState({basicAddedFilters: updateBasicFilters})
              
             
        } else {
            let updateAdvancedFilters = this.state.filters.map((el) => {
                if(el.dummyId == dummyId){
                return {...el, value}
                } else return el
            })
            this.setState({filters: updateAdvancedFilters})
        }

    }


    renderValue = (rowData, e) => {
        let type = rowData.columnType;
        let value = rowData.value;
        let multiSelectOptions = (rowData && rowData.filterOptions) || [];

        let inputType = {
            'null': (
                    <InputText
                        className="p-col-12"
                        value={value}
                        onChange={(e) => {this.handleTableValueChange(rowData, e)}}
                        placeholder={"Enter Value"} />
            ),
            'date': (
                        <Calendar 
                        dateFormat="mm/dd/yy"
                        placeholder={moment(value).format('MM/DD/YYYY')}
                        value={moment(value).format('MM/DD/YYYY')}
                        name='valueFilter' 
                        key={rowData.dummyId} 
                        onChange={(e) => {this.handleTableValueChange(rowData, e)}} 
                        {...CALENDAR_CONFIG}
                        /> 
            ),
            'string': (
                    <InputText
                        className="p-col-12"
                        value={value}
                        onChange={(e) => {this.handleTableValueChange(rowData, e)}}
                        placeholder={"Enter Value"} />
            ),
            "int": (
                    <InputText
                        className="p-col-12"
                        value={value}
                        onChange={(e) => {this.handleTableValueChange(rowData, e)}}
                        keyfilter="int"
                        placeholder={"Enter Value"}
                        />),
            "dec": (
                    <InputText
                        className="p-col-12"
                        value={value}
                        onChange={(e) => {this.handleTableValueChange(rowData, e)}}
                        keyfilter="int"
                        placeholder={"Enter Value"}
                        />),
            "guid": (
                <MultiSelect
                    placeholder={"Choose value"}
                    value={(!Array.isArray(value)) ? rowData.value.split(',') : value}
                    options={multiSelectOptions} 
                    onChange={(e) => {this.handleTableValueChange(rowData, e)}}
                    filter={true}
                    autoWidth={true}
                    className="p-col-12" />),
            'nstring': (
                <MultiSelect
                    placeholder={"Choose value"}
                    value={(!Array.isArray(value)) ? rowData.value.split(',') : value}
                    options={multiSelectOptions}  
                    onChange={(e) => {this.handleTableValueChange(rowData, e)}}
                    filter={true}
                    autoWidth={true}
                    className="p-col-12" />),
            'bit': (
                <MultiSelect
                    placeholder={"Choose value"}
                    value={value} 
                    options={this.state.bitOptions}  
                    onChange={(e) => {this.handleTableValueChange(rowData, e)}}
                    filter={true}
                    autoWidth={true}
                    className="p-col-12" />),
        }
        return inputType[type];
    }

    renderOperator = (rowData) => {
        let type = rowData.columnType;
        let filterType = rowData.filterType;
        // let value;
        let id = rowData.dummyId;
        let value = rowData.operator;

        let operatorOptions = {
            null: [
                {label:'Equal To', value:'='},
                {label:'Greater Than', value:'>'},
                {label:'Greater Than or Equal To', value:'>='},
                {label:'Lesser Than', value:'<'},
                {label:'Lesser Than or Equal To', value:'<='},
                {label:'Contains', value:'contains'},
                {label:'Equal To', value:'='},
                {label:'In', value:'in'}
            ],
            date: [
                {label:'Equal To', value:'='},
                {label:'Greater Than', value:'>'},
                {label:'Greater Than or Equal To', value:'>='},
                {label:'Lesser Than', value:'<'},
                {label:'Lesser Than or Equal To', value:'<='}
            ],
            string: [
                {label:'Contains', value:'contains'},
                {label:'Equal To', value:'='},
                {label:'In', value:'in'},
            ],
            int: [
                {label:'Equal To', value:'='},
                {label:'Greater Than', value:'>'},
                {label:'Greater Than or Equal To', value:'>='},
                {label:'Lesser Than', value:'<'},
                {label:'Lesser Than or Equal To', value:'<='},
            ],
            dec: [
                {label:'Equal To', value:'='},
                {label:'Greater Than', value:'>'},
                {label:'Greater Than or Equal To', value:'>='},
                {label:'Lesser Than', value:'<'},
                {label:'Lesser Than or Equal To', value:'<='},
            ],
            guid: [
                {label:'Equal To', value:'='},
                {label:'In', value:'in'},
            ],
            nstring: [
                {label:'Equal To', value:'='},
                {label:'In', value:'in'},
            ],
            bit: [
                {label:'Equal To', value:'='}
            ]
        }
 


        return (
            <Dropdown
                placeholder = "Select Operator"
                options={operatorOptions[type]}
                value={value}
                name = {filterType}
                id = {id}
                key = {id}
                onChange={(e) => {this.handleTableOperatorChange(rowData, e)}}
                style={{ width: '100%' }}
                {...DROPDOWN_CONFIG} />
        )
        
    }

    handleGroupByAggregateColumn(name, value){
        let groupByAggregateColumn = value;
        let summaryColumn = this.state.displaySummaryColumns || '';
        let groupByColumnOptions = summaryColumn.filter((el) => el.value != groupByAggregateColumn);
        let groupByColumnValues = groupByColumnOptions.map((el) => el.value);
        let groupByColumnNames = groupByColumnOptions.map((el) => {
            let stageNumber = (el.filterType == 'advanced' ? `00${(+el.stageNum) - 1}` : '');
            let fieldName = el.label;
            return fieldName + stageNumber.toString();
        });

        let selectedColumn = this.state.stageFieldCopy.filter((el) => el.stageFieldID == value);
        let fieldValidation = selectedColumn[0].fieldValidation.toLowerCase() || 'null';
        let fieldName = selectedColumn[0].fieldDescription || '';

        if(fieldValidation == 'int'){
            this.setState({
                groupByFunctionOptions:[
                    {label:'Sum',value:'sum'},
                    {label:'Count',value:'count'},
                    {label:'Average',value:'Average'},
                    {label:'Maximum',value:'Maximum'},
                    {label:'Minimum',value:'Minimum'},
                    {label:'Count',value:'Count'},
                ]
            })
        } else {
            this.setState({
                groupByFunctionOptions:[
                    {label:'Count',value:'Count'},
                ]
            })
        }

        this.setState({groupByColumnOptions: groupByColumnOptions, groupByColumnValues:groupByColumnValues, groupByColumnNames:groupByColumnNames});
    }

    handleReportTypeChange = (e) => {
        let reportType = this.state.reportType;
        reportType = e.value;
        this.setState({ reportType});
        let isTabularReportSelected = false;
        let isSummaryReportSelected = false;
        if(this.state.reportType.length > 0){
            if (reportType.includes(1) || reportType.includes('1')){
                isTabularReportSelected = true;
            } 
            if (reportType.includes(2)|| reportType.includes('2')){
                isSummaryReportSelected = true;
            }
        }
        if(!isTabularReportSelected){
            this.setState({
                basicAddedFilters: [],
                filters: [],
            })
            this.basicFilterFieldsReset();
            this.advancedFilterFieldsReset();
        }
        if(!isSummaryReportSelected){
            // this.summaryColumnReset();
            this.summaryFieldsReset();
        }
    }

    changeData = (e, element) =>{
        let { name, value } = e.target;
        this.setState({[name]:value});
        if((name == 'columnFilter' || name == 'basicColumnFilter') && (value == null || value == undefined ) ){
            this.resetFillterOptions(name);
            return
        }
        if(value && (name == 'columnFilter' || name == 'basicColumnFilter') ){
            this.setOperatorOptions(value, name)
        }
        if(value && name == 'groupByAggregateColumn' ){
            this.handleGroupByAggregateColumn(name, value);
        }
        this.setState({reportGenerated: false});
    }

    resetFillterOptions(name) {
        if(name == 'columnFilter'){
            this.setState({
                operatorType: 'false', 
                fieldName:'',
                fieldValidation:'',
                operators: null,
                columnFilter: null,
                valueFilter: '',
                inclusiveOrExclusive: 'inclusive',
                nesting: 'N/A',
                conditionCombiner: 'and',
            });
        } else{
            this.setState({
                basicOperatorType: 'false', 
                basicFieldName:'',
                basicFieldValidation:'',
                basicOperators: null,
                basicColumnFilter: null,
                basicValueFilter: '',
                basicInclusiveOrExclusive: 'inclusive',
                basicNesting: 'N/A',
                basicConditionCombiner: 'and',
            });
        }
        
    }
    //----------------common-functions-end---------------------


    //----------------applier-functions-start---------------------


    handleDeleteItem(dummyId, filterType) {
        if(filterType == 'advanced'){
            // let selectedItemIndex = index - 1 ;
            let index = 1;
            let newArr = this.state.filters.filter((el => el.dummyId != dummyId)).map(el => {
                return{...el, index: index++}
            });
            // newArr.splice(selectedItemIndex, 1);
            // let newIndex = (newArr.length  == 0) ? 0 : (newArr.length - 1);
            this.setState({
                filters:newArr,
                // index:newIndex
            })
        } else if (filterType == 'basic'){
            let index = 1;
            let newArr = this.state.basicAddedFilters.filter((el => el.dummyId != dummyId)).map(el => {
                return{...el, index: index++}
            });
            // newArr.splice(selectedItemIndex, 1);
            // let newIndex = (newArr.length  == 0) ? 0 : (newArr.length - 1);
            this.setState({
                basicAddedFilters:newArr,
                // index:newIndex
            })
        }
    }

    handleDeleteOrderByItem(value) {
        let newOrderBy = this.state.orderBy.filter(el => el.columnValue != value);        
        this.setState({orderBy:newOrderBy});
    }

    handleEditItem = (rowData, type, filterType) => {

        if(filterType == 'advanced'){
            let rowDataCopy = {};
            for(let key in rowData){
                rowDataCopy[key] = rowData[key];
            }

            let index = rowData.index;
            let dummyId = rowData.dummyId;
            let column = rowData.column;
            let columnName = rowData.columnName;
            let columnType = rowData.columnType;
            let operator = rowData.operator;
            let value = ((columnType == 'guid' || columnType == 'nstring') && (!Array.isArray(rowData.value))) ? rowData.value.split(',') : rowData.value;
            let inclusiveOrExclusive = rowData.inclusiveOrExclusive;
            let nestingValue = rowData.nestingValue;
            let logicalOperator = rowData.logicalOperator;

            let newArr = this.state.filters.filter((el) => el.dummyId != dummyId);
            // let newArr = this.state.filters.filter((el) => el.dummyId != dummyId);

            this.setState({
                currentSelectedFilter:rowData,
                indexOfCurrentSelectedFilter:index,
                dummyId:dummyId,
                columnFilter: column,
                fieldName: columnName,
                fieldValidation: columnType,
                operatorType: columnType,
                operatorFilter: operator,
                valueFilter : value,
                inclusiveOrExclusive: inclusiveOrExclusive,
                nesting: nestingValue,
                conditionCombiner: logicalOperator,
                filters: newArr,
                reportGenerated: false,
                startedEditingAdvanceFilter:true
            })
            this.setOperatorOptions(column, 'columnFilter');
            
        } else if(filterType == 'basic'){
            let rowDataCopy = {};
            for(let key in rowData){
                rowDataCopy[key] = rowData[key];
            }

            let index = rowData.index;
            let dummyId = rowData.dummyId;
            let column = rowData.column;
            let columnName = rowData.columnName;
            let columnType = rowData.columnType;
            let operator = rowData.operator;
            let value = ((columnType == 'guid' || columnType == 'nstring') && (!Array.isArray(rowData.value))) ? rowData.value.split(',') : rowData.value;
            let inclusiveOrExclusive = rowData.inclusiveOrExclusive;
            let nestingValue = rowData.nestingValue;
            let logicalOperator = rowData.logicalOperator;

            let newArr = this.state.basicAddedFilters.filter((el) => el.dummyId != dummyId);

            this.setState({
                currentSelectedBasicFilter:rowData,
                indexOfCurrentSelectedBasicFilter:index,
                basicDummyId:dummyId,
                basicColumnFilter: column,
                basicFieldName: columnName,
                basicFieldValidation: columnType,
                basicOperatorFilter: operator,
                basicOperatorType: columnType,
                basicValueFilter : value,
                basicInclusiveOrExclusive: inclusiveOrExclusive,
                basicNesting: nestingValue,
                basicConditionCombiner: logicalOperator,
                basicAddedFilters: newArr,
                reportGenerated: false,
                startedEditingBasicFilter:true
            })
            this.setOperatorOptions(column, 'basicFilter');
        }
    }

    handleCancelEditItem(filterType) {
        if(filterType == 'advancedFilter'){
            let currentSelectedFilter = this.state.currentSelectedFilter;
            let index = +this.state.indexOfCurrentSelectedFilter - 1;
            let filters = this.state.filters;
            filters.splice(index, 0, currentSelectedFilter);
            this.setState({
                currentSelectedFilter:null,
                filters,
                indexOfCurrentSelectedFilter: '',
                columnFilter: null,
                fieldName: '',
                fieldValidation: '',
                operatorFilter: null,
                operatorType: '',
                valueFilter: '',
                from: null,
                to: null,
                inclusiveOrExclusive: 'inclusive',
                nesting: 'N/A',
                conditionCombiner: 'and',
                startedEditingAdvanceFilter: false,
            })
        } else if(filterType == 'basicFilter'){
            let currentSelectedFilter = this.state.currentSelectedBasicFilter;
            let index = +this.state.indexOfCurrentSelectedBasicFilter - 1;
            let basicAddedFilters = this.state.basicAddedFilters;
            basicAddedFilters.splice(index, 0, currentSelectedFilter);

            this.setState({
                currentSelectedBasicFilter:null,
                basicAddedFilters,
                indexOfCurrentSelectedBasicFilter: '',
                basicColumnFilter: null,
                basicFieldName: '',
                basicFieldValidation: '',
                basicOperatorFilter: null,
                basicOperatorType: '',
                basicValueFilter: '',
                from: null,
                to: null,
                basicInclusiveOrExclusive: 'inclusive',
                basicNesting: 'N/A',
                basicConditionCombiner: 'and',
                startedEditingBasicFilter:false,
            })
        }
    }

    handleUpdateItem(filterType) {
        if(filterType == 'advancedFilter'){
            let toBeAddedValue;
            let index = +this.state.indexOfCurrentSelectedFilter - 1;
    
            let label;
            if(this.state.fieldValidation == 'guid' || this.state.fieldValidation == 'nstring'){
                if(this.state.valueFilter.length == 1){
                    label =  this.state.multiSelectOptions.find(el => el.value == this.state.valueFilter.toString()).label || '';
                }else if(this.state.valueFilter.length > 1){
                    label = this.state.valueFilter.map((element) => {
                        return this.state.multiSelectOptions.find(el => el.value == element.toString()).label || ''
                    }).toString();
                }
            } else {
                label = this.state.valueFilter;
            }
    
    
            let value = {
                index: this.state.indexOfCurrentSelectedFilter,
                dummyId: this.state.dummyId,
                column: this.state.columnFilter,
                columnName: this.state.fieldName,
                columnType: this.state.fieldValidation,
                operator: this.state.operatorFilter,
                value: this.state.valueFilter ,
                inclusiveOrExclusive: this.state.inclusiveOrExclusive,
                nestingValue: this.state.nesting,
                logicalOperator: this.state.conditionCombiner,
    
                label
            }
            if(this.state.operatorType == 'date'){
                toBeAddedValue =  moment(value.value).format('MM/DD/YYYY')
                value.value = toBeAddedValue;
    
                value.label = toBeAddedValue;
            }
            let filters = this.state.filters;
            filters.splice(index, 0, value)
            this.setState({
                currentSelectedFilter:null,
                filters,
                indexOfCurrentSelectedFilter: '',
                columnFilter: null,
                fieldName: '',
                fieldValidation: '',
                operatorFilter: null,
                operatorType: '',
                valueFilter: '',
                from: null,
                to: null,
                inclusiveOrExclusive: 'inclusive',
                nesting: 'N/A',
                conditionCombiner: 'and',
                multiSelectOptions: [],
                operators: [],
                operatorType: '',
                startedEditingAdvanceFilter: false
            })
        } else if (filterType == 'basicFilter'){
            let toBeAddedValue;
            let index = +this.state.indexOfCurrentSelectedBasicFilter - 1;
    
            let label;
            if(this.state.basicFieldValidation == 'guid' || this.state.basicFieldValidation == 'nstring'){
                if(this.state.basicValueFilter.length == 1){
                    label =  this.state.basicMultiSelectOptions.find(el => el.value == this.state.basicValueFilter.toString()).label || '';
                }else if(this.state.basicValueFilter.length > 1){
                    label = this.state.basicValueFilter.map((element) => {
                        return this.state.basicMultiSelectOptions.find(el => el.value == element.toString()).label || ''
                    }).toString();
                }
            } else {
                label = this.state.valueFilter;
            }
    
            let value = {
                index: this.state.indexOfCurrentSelectedBasicFilter,
                dummyId: this.state.basicDummyId,
                column: this.state.basicColumnFilter,
                columnName: this.state.basicFieldName,
                columnType: this.state.basicFieldValidation,
                operator: this.state.basicOperatorFilter,
                value: this.state.basicValueFilter ,
                inclusiveOrExclusive: this.state.basicInclusiveOrExclusive,
                nestingValue: this.state.basicNesting,
                logicalOperator: this.state.basicConditionCombiner,
                label
            }
    
            if(this.state.basicOperatorType == 'date'){
                toBeAddedValue =  moment(value.value).format('MM/DD/YYYY')
                value.value = toBeAddedValue;
                
                value.label = toBeAddedValue;
            }
    
            let basicAddedFilters = this.state.basicAddedFilters;
            basicAddedFilters.splice(index, 0, value);
    
            this.setState({
                currentSelectedBasicFilter:null,
                basicAddedFilters,
                indexOfCurrentSelectedBasicFilter: '',
                basicColumnFilter: null,
                basicFieldName: '',
                basicFieldValidation: '',
                basicOperatorFilter: null,
                basicOperatorType: '',
                basicValueFilter: '',
                from: null,
                to: null,
                basicInclusiveOrExclusive: 'inclusive',
                basicNesting: 'N/A',
                basicConditionCombiner: 'and',
                startedEditingBasicFilter:false,
            })
        }
    }

    handleDummy(){
        let val = Math.floor(1000 + Math.random() * 9000);
    }

    manageFilterAddition(filterType) {        
        if(filterType == 'advancedFilter'){
            let val = Math.floor(1000 + Math.random() * 9000);
            let index = (this.state.type == 'add') ? this.state.index : this.state.filters.length;
            index ++;
            let toBeAddedValue;
            let label;
            if(this.state.fieldValidation == 'guid' || this.state.fieldValidation == 'nstring'){
                if(this.state.valueFilter.length == 1){
                    label =  this.state.multiSelectOptions.find(el => el.value == this.state.valueFilter.toString()).label || '';
                }else if(this.state.valueFilter.length > 1){
                    label = this.state.valueFilter.map((element) => {
                        return this.state.multiSelectOptions.find(el => el.value == element.toString()).label || ''
                    }).toString();
                }
            } else {
                label = this.state.valueFilter;
            }
            let value = {
                index,
                dummyId: val,
                column: this.state.columnFilter,
                columnName: this.state.fieldName,
                columnType: this.state.fieldValidation,
                operator: this.state.operatorFilter,
                value: this.state.valueFilter ,
                inclusiveOrExclusive: this.state.inclusiveOrExclusive,
                nestingValue: this.state.nesting,
                logicalOperator: this.state.conditionCombiner,
                label,
                filterType:"advanced",
                filterOptions: this.state.multiSelectOptions
            }
            if(this.state.operatorType == 'date'){
                toBeAddedValue =  moment(value.value).format('MM/DD/YYYY')
                value.value = toBeAddedValue;
                value.label = toBeAddedValue;
            }
            this.setState(prevState => ({
                filters: [...prevState.filters, value]
            }))
            this.setState({
                index,
                columnFilter: null,
                fieldName: '',
                fieldValidation: '',
                operatorFilter: null,
                valueFilter: '',
                from: null,
                to: null,
                inclusiveOrExclusive: 'inclusive',
                nesting: 'N/A',
                conditionCombiner: 'and',
                multiSelectOptions: [],
                operators: [],
                operatorType: '',
            })
        } else {
            let val = Math.floor(1000 + Math.random() * 9000);
            let index = (this.state.type == 'add') ? this.state.basicFilterIndex : this.state.basicAddedFilters.length;
            index ++;
            let toBeAddedValue;
            let label;
            if(this.state.basicFieldValidation == 'guid' || this.state.basicFieldValidation == 'nstring'){
                if(this.state.basicValueFilter.length == 1){
                    label =  this.state.basicMultiSelectOptions.find(el => el.value == this.state.basicValueFilter.toString()).label || '';
                }else if(this.state.basicValueFilter.length > 1){
                    label = this.state.basicValueFilter.map((element) => {
                        return this.state.basicMultiSelectOptions.find(el => el.value == element.toString()).label || ''
                    }).toString();
                }
            } else {
                label = this.state.valueFilter;
            }
            let value = {
                index,
                dummyId: val,
                column: this.state.basicColumnFilter,
                columnName: this.state.basicFieldName,
                columnType: this.state.basicFieldValidation,
                operator: this.state.basicOperatorFilter,
                value: this.state.basicValueFilter ,
                inclusiveOrExclusive: this.state.basicInclusiveOrExclusive,
                nestingValue: this.state.basicNesting,
                logicalOperator: this.state.basicConditionCombiner,
                label,
                filterType:"basic",
                filterOptions: this.state.basicMultiSelectOptions
            }
            if(this.state.basicOperatorType == 'date'){
                toBeAddedValue =  moment(value.value).format('MM/DD/YYYY')
                value.value = toBeAddedValue;
                value.label = toBeAddedValue;
            }
            this.setState(prevState => ({
                basicAddedFilters: [...prevState.basicAddedFilters, value]
            })) //need to change 'filters'
            this.setState({
                basicFilterIndex: index,
                basicColumnFilter: null,
                basicFieldName: '',
                basicFieldValidation: '',
                basicOperatorFilter: null,
                basicValueFilter: '',
                from: null,
                to: null,
                basicInclusiveOrExclusive: 'inclusive',
                basicNesting: 'N/A',
                basicConditionCombiner: 'and',
                basicMultiSelectOptions: [],
                basicOperators: [],
                basicOperatorType: '',
            })
        }
    }
 
    handleAddSummaryColumn() {
        // Available Summary Columns 
        if(this.state.selectedAvailableSummaryColumns !== null && this.state.selectedAvailableSummaryColumns !== undefined && this.state.selectedAvailableSummaryColumns !== []){
            let toBeAddedColumns = this.state.selectedAvailableSummaryColumns.map(el => el);
            
            this.setState(prevState => ({
                displaySummaryColumns: [...prevState.displaySummaryColumns, ...toBeAddedColumns]
            }));

            let toBeAddedValues = toBeAddedColumns.map(el => el.value);

            let newAvailableSummaryColumns = this.state.availableSummaryColumns.filter((el) => { //filtering all added summary column rows from "available summary column"
                return toBeAddedValues.includes(el.value) == false;
            });

            this.setState({availableSummaryColumns:newAvailableSummaryColumns,selectedAvailableSummaryColumns:[], globalFilter:null})
        }else {
            this.growl.show({ severity: 'error', summary: null, detail: 'Select Required Summary Columns' });
            return;
        }
    }

    handleRemoveSummaryColumns() {
        //Display Summary Columns
        if(this.state.selectedDisplaySummaryColumns != null && this.state.selectedDisplaySummaryColumns != undefined && this.state.selectedDisplaySummaryColumns != []){
            let toBeRemovedColumns = this.state.selectedDisplaySummaryColumns.map(el => el);

            this.setState(prevState => ({
                availableSummaryColumns: [...prevState.availableSummaryColumns, ...toBeRemovedColumns]
            }));

            let toBeRemovedValues = toBeRemovedColumns.map(el => el.value);

            let newDisplaySummaryColumns = this.state.displaySummaryColumns.filter((el) => {
                return toBeRemovedValues.includes(el.value) == false;
            });

            this.setState({displaySummaryColumns:newDisplaySummaryColumns,  selectedDisplaySummaryColumns:[], globalFilter:null})
        }else {
            this.growl.show({ severity: 'error', summary: null, detail: 'Select Required Columns' });
            return;
        }
    }

    handleAddColumns() {
        if(this.state.selectedAvailableColumns !== null && this.state.selectedAvailableColumns !== undefined && this.state.selectedAvailableColumns !== []){
            let toBeAddedColumns = this.state.selectedAvailableColumns.map(el => el);
            
            this.setState(prevState => ({
                selectedFilters: [...prevState.selectedFilters, ...toBeAddedColumns],
                availableSummaryColumns: [...prevState.selectedFilters, ...toBeAddedColumns],
            }));

            setTimeout(() => {
                let basicFilters = this.state.selectedFilters.filter(el => el.filterType == 'basic')
                let advancedFilters = this.state.selectedFilters.filter(el => el.filterType == 'advanced')
                this.setState(prevState => ({
                    basicFilters, advancedFilters
                }));
            }, 300)

            let toBeAddedValues = toBeAddedColumns.map(el => el.value);

            let newStageField = this.state.stageField.filter((el) => {
                return toBeAddedValues.includes(el.value) == false;
            });

            this.setState({stageField:newStageField,selectedAvailableColumns:[], globalFilter:null})
        }else {
            this.growl.show({ severity: 'error', summary: null, detail: 'Select Required Columns' });
            return;
        }

        
    }

    handleRemoveColumns() {
        if(this.state.selectedDisplayColumns != null && this.state.selectedDisplayColumns != undefined && this.state.selectedDisplayColumns != []){
            let toBeRemovedColumns = this.state.selectedDisplayColumns.map(el => el);

            this.setState(prevState => ({
                stageField: [...prevState.stageField, ...toBeRemovedColumns]
            }));

            let toBeRemovedValues = toBeRemovedColumns.map(el => el.value);

            let newSelectedFilters = this.state.selectedFilters.filter((el) => {
                return toBeRemovedValues.includes(el.value) == false;
            });

            let newBasicFilters = this.state.basicFilters.filter((el) => {
                return toBeRemovedValues.includes(el.value) == false;
            });
            let newAdvancedFilters = this.state.advancedFilters.filter((el) => {
                return toBeRemovedValues.includes(el.value) == false;
            });

            this.setState({selectedFilters:newSelectedFilters,availableSummaryColumns: newSelectedFilters, basicFilters:newBasicFilters, advancedFilters:newAdvancedFilters, selectedDisplayColumns:[], globalFilter:null})
        }else {
            this.growl.show({ severity: 'error', summary: null, detail: 'Select Required Columns' });
            return;
        }
    }

    handleOrderByAddition() {    
        let columnValue = this.state.orderByColumn;
        let sequence = this.state.orderBySequence;
        let stageField = this.state.stageFieldCopy;
        let columnName = stageField.find(el => el.stageFieldID == columnValue).fieldDescription || 'wrong';
        let value = {
            columnValue,
            sequence,
            columnName
        };
        this.setState(prevState => ({
            orderBy: [...prevState.orderBy, value]
        }))
        this.orderByFieldsReset();

    }

    setOperatorOptions(id, name) {
        if(name == 'columnFilter'){
            let selectedColumn;
            selectedColumn = this.state.stageFieldCopy.filter((el) => el.stageFieldID == id)
            let fieldValidation = selectedColumn[0].fieldValidation.toLowerCase() || 'null';
            let fieldName = selectedColumn[0].fieldDescription || '';

            if(fieldValidation == 'null'){
                this.setState({
                    fieldName,
                    fieldValidation,
                    operatorType: fieldValidation,  
                    operators: [
                        {label:'Equal To', value:'='},
                        {label:'Greater Than', value:'>'},
                        {label:'Greater Than or Equal To', value:'>='},
                        {label:'Lesser Than', value:'<'},
                        {label:'Lesser Than or Equal To', value:'<='},
                        {label:'Contains', value:'contains'},
                        {label:'Equal To', value:'='},
                        {label:'In', value:'in'},
                    ]
                });
            }


            if(fieldValidation == 'date'){
                this.setState({
                    fieldName,
                    fieldValidation,
                    operatorType: fieldValidation,
                    operators: [
                        {label:'Equal To', value:'='},
                        {label:'Greater Than', value:'>'},
                        {label:'Greater Than or Equal To', value:'>='},
                        {label:'Lesser Than', value:'<'},
                        {label:'Lesser Than or Equal To', value:'<='},
                    ]
                });
            } else if(fieldValidation == 'string' ){
                this.setState({
                    fieldName,
                    fieldValidation,
                    operatorType: fieldValidation,
                    operators: [
                    {label:'Contains', value:'contains'},
                    {label:'Equal To', value:'='},
                    {label:'In', value:'in'},
                    ],
                });
            } else if(fieldValidation == "int" || fieldValidation == "dec"){
                this.setState({
                    fieldName,
                    fieldValidation,
                    operatorType: fieldValidation,
                    operators: [
                    {label:'Equal To', value:'='},
                    {label:'Greater Than', value:'>'},
                    {label:'Greater Than or Equal To', value:'>='},
                    {label:'Lesser Than', value:'<'},
                    {label:'Lesser Than or Equal To', value:'<='},
                ]
                });
            } else if(fieldValidation == "guid" || fieldValidation == 'nstring'){
                this.setState({loading: true});
                this.loadDropdownValues(selectedColumn);
                this.setState({
                    fieldName,
                    fieldValidation,
                    operatorType: fieldValidation, 
                    operators: [
                    {label:'Equal To', value:'='},
                    {label:'In', value:'in'},
                    ],
                });
            } else if(fieldValidation == 'bit'){
                this.setState({
                    fieldName,
                    fieldValidation,
                    operatorType: fieldValidation, 
                    operators: [
                    {label:'Equal To', value:'='},
                ]
                });
            }
        } else {
            let selectedColumn;
            selectedColumn = this.state.stageFieldCopy.filter((el) => el.stageFieldID == id)
            let basicFieldValidation = selectedColumn[0].fieldValidation.toLowerCase() || 'null';
            let  basicFieldName = selectedColumn[0].fieldDescription || '';

            if(basicFieldValidation == 'null'){
                this.setState({
                    basicFieldName,
                    basicFieldValidation,
                    basicOperatorType: basicFieldValidation, 
                    basicOperators: [
                        {label:'Equal To', value:'='},
                        {label:'Greater Than', value:'>'},
                        {label:'Greater Than or Equal To', value:'>='},
                        {label:'Lesser Than', value:'<'},
                        {label:'Lesser Than or Equal To', value:'<='},
                        {label:'Contains', value:'contains'},
                        {label:'Equal To', value:'='},
                        {label:'In', value:'in'},
                    ]
                });
            }


            if(basicFieldValidation == 'date'){
                this.setState({
                    basicFieldName,
                    basicFieldValidation,
                    basicOperatorType: basicFieldValidation, 
                    basicOperators: [
                        {label:'Equal To', value:'='},
                        {label:'Greater Than', value:'>'},
                        {label:'Greater Than or Equal To', value:'>='},
                        {label:'Lesser Than', value:'<'},
                        {label:'Lesser Than or Equal To', value:'<='},
                    ]
                });
            } else if(basicFieldValidation == 'string' ){
                this.setState({
                    basicFieldName,
                    basicFieldValidation,
                    basicOperatorType: basicFieldValidation, 
                    basicOperators: [
                    {label:'Contains', value:'contains'},
                    {label:'Equal To', value:'='},
                    {label:'In', value:'in'},
                    ],
                });
            } else if(basicFieldValidation == "int" || basicFieldValidation == "dec"){
                this.setState({
                    basicFieldName,
                    basicFieldValidation,
                    basicOperatorType: basicFieldValidation, 
                    basicOperators: [
                    {label:'Equal To', value:'='},
                    {label:'Greater Than', value:'>'},
                    {label:'Greater Than or Equal To', value:'>='},
                    {label:'Lesser Than', value:'<'},
                    {label:'Lesser Than or Equal To', value:'<='},
                ]
                });
            } else if(basicFieldValidation == "guid" || basicFieldValidation == 'nstring'){
                this.setState({loading: true});
                this.loadDropdownValues(selectedColumn);
                this.setState({
                    basicFieldName,
                    basicFieldValidation,
                    basicOperatorType: basicFieldValidation, 
                    basicOperators: [
                    {label:'Equal To', value:'='},
                    {label:'In', value:'in'},
                    ],
                });
            } else if(basicFieldValidation == 'bit'){
                this.setState({
                    basicFieldName,
                    basicFieldValidation,
                    basicOperatorType: basicFieldValidation, 
                    basicOperators: [
                    {label:'Equal To', value:'='},
                ]
                });
            }
        }
    }

    loadDropdownValues(selectedColumn) {
        let hasAdminAccess = this.state.adminAccess;
        let isHrDepartment = this.state.isHrDepartment;
        let selectedColumnType = selectedColumn[0].stageName.length > 0 ? 'advanced' : 'basic';
        let dropdownKeyword = selectedColumn[0].groupingfieldvalue;
        let valueNode = selectedColumn[0].validationAPI;
        let dropDownOptions;

        let url;
        if(hasAdminAccess || isHrDepartment){
            url = `/master/api/DropDownValues/${dropdownKeyword}`
        }else {
            if(dropdownKeyword == 'employee' ){
                url = `/master/api/DropDownValues/${this.props.loggedUserDetail.empID}/SP_GET_SUBORDINATES_REP`
            }else if(dropdownKeyword == 'OrgUnit'){
                url = `/master/api/DropDownValues/${this.props.loggedUserDetail.empID}/SP_GET_SUBORDINATE_ORG`
            }
        }

        axios.get(url)
                .then(response => {
                    if (response.status === 200) {     
                        dropDownOptions = response.data.map(element => {
                            return { label: element.text, value: element[valueNode], ...element }
                        });
                        if(selectedColumnType == 'advanced'){
                            this.setState({loading: false, multiSelectOptions: dropDownOptions});
                        } else {
                            this.setState({loading: false, basicMultiSelectOptions: dropDownOptions});
                        }
                    }
                })
                .catch(err => {
                    this.setState({loading: false,});
                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed To load DropDown Options, Please Try again later' });
                })       

    }

    saveReport = (type) => {


        let saveType = type;
        let basicFilters = this.state.basicAddedFilters || [];
        //basicFilters[basicFilters.length - 1].logicalOperator = "N/A";
        let advancedFilters = this.state.filters || [];
        //advancedFilters[advancedFilters.length - 1].logicalOperator = "N/A";
        let filters = advancedFilters.concat(basicFilters) || [];
        let ReportSettings;
        let ReportSettingsAdvanceFilterListrun;
        let ReportSettingSummaryType;
        let ReportSettingsOrderbyListRun;
        // let columnNames = this.state.selectedFilters && this.state.selectedFilters.map((el) => el.toSendToBckend).toString();//*****
        let columnNames = this.state.selectedFilters && this.state.selectedFilters.map((el) => el.label).toString();//*****
              console.log("selectedFilters:", this.state.selectedFilters);
              console.log("columnNames:", columnNames);
        let columnValues = this.state.selectedFilters && this.state.selectedFilters.map((el) => el.value).toString();
        let orderByValues = this.state.orderBy && this.state.orderBy.map((el) => el.columnValue).toString();
        let orderByNames = this.state.orderBy && this.state.orderBy.map((el) => el.columnName).toString();
        let orderBySequence = this.state.orderBy && this.state.orderBy.map((el) => el.sequence).toString();
        let orderBy = this.state.orderBy;
        let {reloadedreportSettingSummaryTypeList, reloadedreportSettings, reloadedreportSettingsAdvanceFilterList} = this.state || [];
        // columnNames = columnNames.toString();
        // let notColumnNames = this.state.stageField.filter((el) => el.sorted != true );
        // // notColumnNames = notColumnNames.map((el) => el.label).toString();


        

        ReportSettings = {
            ReportSetingsId : saveType == 'edit' ? reloadedreportSettings.reportSetingsId : "00000000-0000-0000-0000-000000000000" ,//editing required for edit report
            ModuleName : 'HR' ,
            ModuleType : 'HR' ,
            MasterName : 'Report Master' ,
            ReportName : this.state.reportName || '' ,
            ReportType : this.state.reportType.toString() ,
            ReportColumnName : columnNames ,
            DateFilterColumn : 'null' ,
            IsDatetypeFilter : 1 ,
            DateFilterDuring : 'null' ,
            DateFilterFrom : new Date() ,
            DateFilterTo : new Date() ,
            AdvanceFilterIsactive : true ,
            GroupGruopbyColumn : 'null' ,
            GruopOrderedby : 'null' ,
            SummaryColumnName : 'null' ,
            SummaryCount : 'null' , 
            SummarySum : 'null' , 
            ChartCharttype : 'null' ,
            ChartAxisColumn : 'null' ,
            ChartDisplayFormat : 'null' ,
            ReportDestination : '1' ,
            ReportDestinUrl : this.state.displaySummaryColumns && this.state.displaySummaryColumns.map(el => el.value).toString() || 'null'  ,//send summary display column values
            ReportDestinFileType : 'null' ,
            ReportDestinEmail  : 'null' ,
            IsActive : true ,
            Createdby : saveType == 'edit' ? reloadedreportSettings.createdby : this.props.loggedUserDetail.empID ,//editing required for edit report
            Createdon : saveType == 'edit' ? reloadedreportSettings.createdon : new Date() ,
            Updatedby : this.props.loggedUserDetail.empID ,
            Updatedon : new Date() ,
            ColumnWidth : 'null' ,
            ColumnDisplayName : columnValues ,
            CompanyId :  this.props.loggedUserDetail.CompanyId, 
            ProcessId :  this.state.processValue, 
        }


        ReportSettingsAdvanceFilterListrun = filters.map(
            (el) => {
                let stageNumber = this.state.stageFieldCopy.filter((element) => {
                    return element.stageFieldID == el.column;})[0].stageName || '';
                stageNumber = parseInt(stageNumber) - 1;
            return{ 
                Id: saveType == 'edit' ? reloadedreportSettingsAdvanceFilterList.id :  123123,//editing required for edit report
                ReportSettingAdvancedFilter: saveType == 'edit' ? reloadedreportSettingsAdvanceFilterList.reportSettingAdvancedFilter : "00000000-0000-0000-0000-000000000000" ,//editing required for edit report
                ReportSettingId: saveType == 'edit' ? reloadedreportSettingsAdvanceFilterList.reportSettingId : "00000000-0000-0000-0000-000000000000" ,//editing required for edit report
                AdvancedFilteringColumn  : el.column ,//send Column
                AdvancedFilteringOperator  : el.operator ,//send operator
                AdvancedFilteringValue : Array.isArray(el.value) ? el.value.toString() : el.value ,//value
                AdvancedFilteringExcludeInclude : el.inclusiveOrExclusive ,//exclusive and inclusive
                AdvancedFilteringLogicalOperator  : el.logicalOperator ,//exclusive and inclusive
                AdvancedFilteringNestingOption  : el. nestingValue,//nesting option
                Customfield4: el.label,
                Customfield3: (stageNumber.length > 0 || !isNaN(stageNumber)) ? 'advanced' : 'basic',
                Customfield2: el.columnName,//*****
                Customfield1: el.columnType,
                Createdby : saveType == 'edit' ? reloadedreportSettingsAdvanceFilterList.createdby : this.props.loggedUserDetail.empID,//editing required for edit report
                Createdon : saveType == 'edit' ? reloadedreportSettingsAdvanceFilterList.createdon :new Date() ,//editing required for edit report
                Updatedby : this.props.loggedUserDetail.empID,
                Updatedon : new Date() ,
                CompanyId :  this.props.loggedUserDetail.CompanyId, 
            }
            }
        )


        ReportSettingSummaryType = {
            Id: 12345678,
            ReportSettingsSummaryId : "00000000-0000-0000-0000-000000000000",
            ReportSettingsId : "00000000-0000-0000-0000-000000000000",
            SummaryName : 'null' ,
            Count : true ,
            Sum : true ,
            Average : true ,
            MaxValue : true ,
            MinValue : true ,
            Createdby : this.props.loggedUserDetail.empID,
            Createdon : new Date() ,
            Updatedby : this.props.loggedUserDetail.empID,
            Updatedon : new Date() ,
            CompanyId :  this.props.loggedUserDetail.CompanyId, 
        }

        ReportSettingsOrderbyListRun = orderBy.map((el) => {
            return{
                ReportSettingOrderby: "00000000-0000-0000-0000-000000000000",
                ReportSettingId: "00000000-0000-0000-0000-000000000000",
                // OrderbyColumn:`${el.columnName}`,
                OrderbyColumn: el.columnName,//NEW
                OrderSequence: el.sequence,//NEW 
                // OrderSequence:`${el.sequence}`,
                Createdby : this.props.loggedUserDetail.empID,
                Createdon : new Date() ,
                Updatedby : this.props.loggedUserDetail.empID,
                Updatedon : new Date() ,
                CompanyId:this.props.loggedUserDetail.CompanyId,
                Customfield1: `${el.columnValue}`,
                Customfield2: `null`,
                Customfield3: `null`,
                Customfield4: `null`,
            }
        })


        let finalData = {
            ReportSettings,
            ReportSettingsAdvanceFilterListrun,
            ReportSettingSummaryType,
            ReportSettingsOrderbyListRun
        }
        if(saveType == 'save'){
            this.props.processDynamicData('CustomReport','add',finalData,'');// this.props.processDynamicData('CustomReport','add',finalData,'');
        } else {
            this.props.processDynamicData('CustomReport','edit',finalData,'');// this.props.processDynamicData('CustomReport','edit',finalData,'');
        }
        
    }
    //----------------applier-functions-end---------------------



    

    //----------------run-report-functions-start---------------------

    componentDidMount() {
        let type = this.props.match.params.type;
        let id = this.props.match.params.id;
        const adminAccess = parseInt(localStorage.getItem('admin'));
        const isHrDepartment = parseInt(localStorage.getItem('hrTeam')); 
        this.setState({type, reportGenerated: false, adminAccess, isHrDepartment});

        this.setState({loading:true})
        axios.get("/master/api/DropDownValues/" + 'SubMenu')
                .then(response => {
                    if (response.status === 200) {
                        let data = response.data.map(el => {
                            return{
                                label: el.text,
                                value: el.uniqueId,
                            }});
                        this.setState({processOptions:data});
                        if(type == "add")  this.setState({loading: false });
                    }
                })
                .catch(err => {
                    this.setState({loading:false});
                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed To load Process List, Please Try again later' });
                })  

        
                
        if(type !== 'add'){
            this.setState({loading:true});
            this.props.getMasterTableList(`Employee/GetCustomReport?Id=${id}`)
            setTimeout(()=>{
                this.fetchReport();
            },3000)
          
        }
        
    }

    async fetchReport() {
        try{
            let type = this.props.match.params.type;
            let id = this.props.match.params.id;
            this.setState({type:type,id:id});
            const {reportSettingSummaryTypeList,reportSettings,reportSettingsAdvanceFilterList, reportSettingsOrderbyList} = this.props.tableLists || {};
            const isMasterReport = (reportSettings.columnWidth == "iNSERT") ? true : false
            let reportType = reportSettings && reportSettings.reportType.split(',').map(el => +el) || [];
            this.setState({reloadedreportSettingSummaryTypeList:reportSettingSummaryTypeList, reloadedreportSettings:reportSettings, reloadedreportSettingsAdvanceFilterList:reportSettingsAdvanceFilterList , reloadedreportSettingsOrderbyList:reportSettingsOrderbyList, reportType, isMasterReport});
            let processId = reportSettings && reportSettings.processId.toString() ||'';
            await this.stageFieldReload(processId, reportSettings);
            this.filterListReload(reportSettingsAdvanceFilterList);
            this.orderByReload();
            
            this.setState({
                reportName: reportSettings && reportSettings.reportName,
                processValue: processId,
            })
        }catch{
            this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong. Please reload report page again' });
        }
        

    }

    stageFieldReload(processId, reportSettings) {
        return new Promise((resolve, reject) => {
            axios.get(`/master/api/GetStageField?processId=${processId}`)
                .then(response => {
                    if (response && response.status === 200) {
                        let stageFieldCopy = response && response.data && response.data.map(el => el) || [];
                        let stageField = response && response.data && response.data.map(s => Object.assign({}, { label: s.fieldDescription, value: s.stageFieldID, stageNum: s.stageName, filterType:(s.stageName.length == 0) ? 'basic' : 'advanced'}))|| [];
                        if(this.state.type == 'edit'){
                            this.setState({stageField, stageFieldCopy});
                            this.availableColumnReload(reportSettings);
                        } else this.setState({stageFieldCopy});
                        this.displayColumnReload(reportSettings);
                        resolve("stageFieldSet");
                    }
                    
                })
                .catch(err => {
                    reject("error")
                    this.setState({ error: 'TA Request Number Api Error', stageField: [], loading: false });
                    this.growl.show({ severity: 'error', summary: null, detail: 'Stage Field API Error' });
                })
        })

    }

    availableColumnReload(data) {
        let {reportColumnName, columnDisplayName, reportDestinUrl} = data;
        let stageFields = this.state.stageFieldCopy;
        let displayColumnFieldValues = columnDisplayName.split(',');
        let summaryDisplayValues = reportDestinUrl.split(',');


        let availableColumns = stageFields.filter((field) => displayColumnFieldValues.includes(field.stageFieldID) == false).map((fields) => {
            return{
                label:fields.fieldDescription,
                value:fields.stageFieldID,
                stageNum:fields.stageName,
                filterType:(fields.stageName.length == 0) ? 'basic' : 'advanced',
            }
        } ) 

        let availableSummaryColumns = stageFields.filter((field) => displayColumnFieldValues.includes(field.stageFieldID)).map((fields) =>{
            return{
                label:fields.fieldDescription,
                value:fields.stageFieldID,
                stageNum:fields.stageName,
                filterType:(fields.stageName.length == 0) ? 'basic' : 'advanced',
            }
        } ).filter((field) => summaryDisplayValues.includes(field.value) == false);


        this.setState({stageField: availableColumns, availableSummaryColumns});


    }

    displayColumnReload(data) {
    let {reportColumnName, columnDisplayName, reportDestinUrl} = data;
    let stageFields = this.state.stageFieldCopy;
    let columnFieldValues = columnDisplayName.split(',');
    let summaryDisplayValues = reportDestinUrl.split(',');
    

    let columnFields = stageFields.filter((field) => columnFieldValues.includes(field.stageFieldID)).map((fields) =>{
        return{
            label:fields.fieldDescription,
            value:fields.stageFieldID,
            stageNum:fields.stageName,
            filterType:(fields.stageName.length == 0) ? 'basic' : 'advanced',
        }
    } )
    let displaySummaryColumns = stageFields.filter((field) => summaryDisplayValues.includes(field.stageFieldID)).map((fields) =>{
        return{
            label:fields.fieldDescription,
            value:fields.stageFieldID,
            stageNum:fields.stageName,
            filterType:(fields.stageName.length == 0) ? 'basic' : 'advanced',
        }
    } )
    let basicFilters = columnFields.filter(el => el.filterType == 'basic')
    let advancedFilters = columnFields.filter(el => el.filterType == 'advanced')
    this.setState({selectedFilters:columnFields, basicFilters, advancedFilters, displaySummaryColumns: columnFields, displaySummaryColumns });

}
    reloadFilterDropdownOptions = (selectedColumnType, selectedColumn, columnId) => {
        return new Promise((resolve, reject) => {
            let url;
            let dropDownOptions = [];
            const dropdownKeyword = selectedColumn.groupingfieldvalue;
            const hasAdminAccess = parseInt(localStorage.getItem('admin'));
            const isHrDepartment = parseInt(localStorage.getItem('hrTeam'));
            const valueNode = selectedColumn.validationAPI;
            

            if(hasAdminAccess || isHrDepartment){
                url = `/master/api/DropDownValues/${dropdownKeyword}`
            }else {
                if(dropdownKeyword == 'employee' ){
                    url = `/master/api/DropDownValues/${this.props.loggedUserDetail.empID}/SP_GET_SUBORDINATES_REP`
                }else if(dropdownKeyword == 'OrgUnit'){
                    url = `/master/api/DropDownValues/${this.props.loggedUserDetail.empID}/SP_GET_SUBORDINATE_ORG`
                }
            }

            axios.get(url).then(response => {
                if (response.status === 200) {     
                    dropDownOptions = response.data.map(element => {
                        return { label: element.text, value: element[valueNode], ...element }
                    });
                    resolve({[columnId]: dropDownOptions});
                }
            }).catch(err => {
                resolve({[columnId]: dropDownOptions});
                this.growl.show({ severity: 'error', summary: null, detail: 'Failed To load DropDown Options, Please Try again later' });
            }) 

        })
    }

    async filterListReload(data) {
        // let a = data && data.map(el => el) || [];
        let index = 0;
        let basicFilters = [];
        let advancedFilters = [];

        const repeating = data && data.filter((el) => (el.customfield1 == "nstring" || el.customfield1 == "guid"));

        const uniqueSet = new Set(repeating);


        let listOfPromises = data && data.filter((el) => (el.customfield1 == "nstring" || el.customfield1 == "guid")).map((el) => {
            if(el.customfield1 == "nstring" || el.customfield1 == "guid"){
                const columnId = el.advancedFilteringColumn;
                const selectedColumn = (this.state && this.state.stageFieldCopy && this.state.stageFieldCopy.find((el) => el.stageFieldID == columnId)) || [];
                const selectedColumnType = el.customfield3;
                return this.reloadFilterDropdownOptions(selectedColumnType, selectedColumn, columnId)
            }
        })

        const responseFromPromises = await Promise.all(listOfPromises);
        

        data && data.forEach((element) => {
            let val = Math.floor(1000 + Math.random() * 9000);
            let value;
            index ++;
            value = { 
                index,
                dummyId: val,
                column: element.advancedFilteringColumn,
                columnName: element.customfield2,
                columnType: element.customfield1,
                operator: element.advancedFilteringOperator,
                value: element.advancedFilteringValue ,
                inclusiveOrExclusive: element.advancedFilteringExcludeInclude,
                nestingValue: element.advancedFilteringNestingOption,
                logicalOperator: element.advancedFilteringLogicalOperator,
                label: element.customfield4,
                filterType: element.customfield3
                }
            if(element.customfield3 == 'basic'){
                let key = responseFromPromises.find((el) => Object.keys(el)[0] == element.advancedFilteringColumn);

                if( element.customfield1 == "nstring" || element.customfield1 == "guid"){
                    let keyValue = key[element.advancedFilteringColumn];
                    value = {...value, "filterOptions": keyValue};
                }

                basicFilters.push(value);
            } else if(element.customfield3 == 'advanced'){
                let key = responseFromPromises.find((el) => Object.keys(el)[0] == element.advancedFilteringColumn);

                if( element.customfield1 == "nstring" || element.customfield1 == "guid"){
                    let keyValue = key[element.advancedFilteringColumn];
                    value = {...value, "filterOptions": keyValue};    
                }

                advancedFilters.push(value);
            }
        })
        

        // let basicFilters = combinedFilters.filter(el => el.filterType == 'basic')
        // let advancedFilters = combinedFilters.filter(el => el.filterType == 'advanced')

        this.setState({index:index + 1, filters:advancedFilters, basicAddedFilters: basicFilters, loading: false});

        
        
        // let index = this.state.index;
        // index ++;
        // let toBeAddedValue;
        // let value = {
        //     index,
        //     dummyId: val,
        //     column: this.state.columnFilter,
        //     operator: this.state.operatorFilter,
        //     value: this.state.valueFilter ,
        //     inclusiveOrExclusive: this.state.inclusiveOrExclusive,
        //     nestingValue: this.state.nesting,
        //     logicalOperator: this.state.conditionCombiner,
        // }
        // if(this.state.operatorType == 'date'){
        //     toBeAddedValue =  moment(value.value).format('MM/DD/YYYY')
        //     value.value = toBeAddedValue
        // }
        // this.setState(prevState => ({
        //     filters: [...prevState.filters, value]
        //   }))
        // this.setState({
        //     index,
        //     columnFilter: null,
        //     operatorFilter: null,
        //     valueFilter: '',
        //     from: null,
        //     to: null,
        //     inclusiveOrExclusive: null,
        //     nesting: [],
        //     conditionCombiner: [],
        // })
    }


    

    orderByReload() {
        let orderBy = this.state.reloadedreportSettingsOrderbyList.map(el => {
            return{
                columnName: el.orderbyColumn,
                columnValue: el.customfield1,
                sequence: el.orderSequence
            }
        }) || [];
    this.setState({orderBy});
    }

    reqDataAvailability(data) {
        let reportType = data;
        let tabularReportSelected = false;
        let summaryReportSelected = false;
        let shouldReturn = false
        if(reportType.length > 0){
            if (reportType.includes(1) || reportType.includes('1')){
                tabularReportSelected = true;
            } 
            if (reportType.includes(2)|| reportType.includes('2')){
                summaryReportSelected = true;
            }
        }

        if(summaryReportSelected){
            let {groupByAggregateColumn,groupByColumnValues,groupByFunction} = this.state || [];
            if(!groupByAggregateColumn|| !groupByColumnValues|| !groupByFunction){
                shouldReturn = true;
            }
        }

        if(shouldReturn) {
            return false;
        } else return true;
    }


    

    runReport() {
        let {reloadedreportSettingSummaryTypeList, reloadedreportSettings, reloadedreportSettingsAdvanceFilterList} = this.state || [];
        let basicFilters = this.state.basicAddedFilters || [];
        if(basicFilters.length > 0 ){
            basicFilters[basicFilters.length - 1].logicalOperator = "N/A";//to make the final condition always have logical operator as "N/A"
        }
        let advancedFilters = this.state.filters || [];
        if(advancedFilters.length > 0 ){
            advancedFilters[advancedFilters.length - 1].logicalOperator = "N/A";//to make the final condition always have logical operator as "N/A"
        }
        let filters = advancedFilters.concat(basicFilters) || [];
        let ReportSettings;
        let ReportSettingsAdvanceFilterListrun;
        let ReportSettingSummaryType;
        let ReportSettingsOrderbyListRun;
        let reqDataAvailable = this.reqDataAvailability(this.state.reportType);
        let SummaryCount = 'null';
        let SummaryColumnName = 'null';
        let orderByValues = this.state.orderBy && this.state.orderBy.map((el) => el.columnValue).toString();
        let orderBySequence = this.state.orderBy && this.state.orderBy.map((el) => el.sequence).toString();
        let orderByNames = this.state.orderBy && this.state.orderBy.map((el) => el.columnName).toString();
        let orderBy = this.state.orderBy;

        if(!reqDataAvailable){
            this.growl.show({ severity: 'error', summary: null, detail: 'Enter Required Summary Fields' });
            return
        }

        let tabularReportSelected = false;
        let summaryReportSelected = false;
        if(this.state.reportType.length > 0){
            if (this.state.reportType.includes(1) || this.state.reportType.includes('1')){
                tabularReportSelected = true;
            } 
            if (this.state.reportType.includes(2)|| this.state.reportType.includes('2')){
                summaryReportSelected = true;
            }
        }

        
        if(summaryReportSelected == true){
            let summaryCountElement = this.state.stageFieldCopy.find((element) => {
                return element.stageFieldID == this.state.groupByAggregateColumn;
            }) || ''; 
            let basicOrAdvance = (!summaryCountElement.stageName.length) ? 'basic' : 'advance';
            let summaryCountStageNum = (basicOrAdvance == 'advance') ? `00${parseInt(summaryCountElement.stageName) - 1}` || '' : '';
            
            SummaryCount = (summaryCountElement && (summaryCountElement.fieldDescription + summaryCountStageNum)) || '';

            SummaryColumnName = (this.state.displaySummaryColumns && this.state.displaySummaryColumns.map((el) =>{//*****
                let stageNumber = (el.filterType == 'advanced' ? `00${(+el.stageNum) - 1}` : '');
                let fieldName = el.label;
                return fieldName + stageNumber.toString();
            })).toString() || 'null'
        }

        

        ReportSettings = {
            ReportSetingsId : reloadedreportSettings.reportSetingsId ,
            ModuleName : 'HR' ,
            ModuleType : 'HR' ,
            MasterName : 'Report Master' ,
            ReportName : reloadedreportSettings.reportName || '' ,
            ReportType : this.state.reportType.toString(),
            ReportColumnName : reloadedreportSettings.reportColumnName ,
            DateFilterColumn : 'null' ,
            IsDatetypeFilter : 1 ,
            DateFilterDuring : 'null' ,
            DateFilterFrom : new Date() ,
            DateFilterTo : new Date() ,
            AdvanceFilterIsactive : true ,
            GroupGruopbyColumn : `${(this.state.groupByColumnNames && this.state.groupByColumnNames.toString()) || 'null'}`,//send group by column name 
            GruopOrderedby : 'null' ,// group ordered column name
            SummaryColumnName : SummaryColumnName ,//send all selected summary column name accoring to other name rules**
            SummaryCount : `${SummaryCount || 'null'}`, //group by aggregate column**
            SummarySum : `${(this.state.groupByFunction && this.state.groupByFunction ) || 'null'}` , //group by aggregate function
            ChartCharttype : 'null' ,
            ChartAxisColumn : 'null' ,
            ChartDisplayFormat : 'null' ,
            ReportDestination : '1' ,
            ReportDestinUrl : 'null' ,
            ReportDestinFileType : 'null' ,
            ReportDestinEmail  : 'null' ,
            IsActive : true ,
            Createdby : this.props.loggedUserDetail.empID ,
            Createdon : reloadedreportSettings.createdon ,
            Updatedby : reloadedreportSettings.updatedby ,
            Updatedon : reloadedreportSettings.updatedon ,
            ColumnWidth : 'null' ,
            ColumnDisplayName : reloadedreportSettings.columnDisplayName ,
            CompanyId :  this.props.loggedUserDetail.companyId, 
            ProcessId :  this.state.processValue, 
        }


        let advanceFilterId = 0
        ReportSettingsAdvanceFilterListrun = filters.map((el) => {
            advanceFilterId++;

            let stageNumber = this.state.stageFieldCopy.filter((element) => {return element.stageFieldID == el.column;})[0].stageName || '';

            stageNumber = parseInt(stageNumber) - 1;
            return{ 
                Id: advanceFilterId,//send empty
                ReportSettingAdvancedFilter :  "00000000-0000-0000-0000-000000000000" ,//send empty
                ReportSettingId : reloadedreportSettings.reportSetingsId || "00000000-0000-0000-0000-000000000000" ,//send empty
                AdvancedFilteringColumn  : el.column ,//send Column
                AdvancedFilteringOperator  : el.operator ,//send operator
                AdvancedFilteringValue : Array.isArray(el.value) ? `'${el.value.toString()}'` : (el.columnType == 'guid') ?  `'${el.value}'` : `${el.value}`,//value
                AdvancedFilteringExcludeInclude : el.inclusiveOrExclusive ,//exclusive and inclusive
                AdvancedFilteringLogicalOperator  : el.logicalOperator ,//exclusive and inclusive
                AdvancedFilteringLogicalNestingOption  : el. nestingValue,//nesting option
                Customfield4: `null`,
                Customfield3: (stageNumber.length > 0 || !isNaN(stageNumber)) ? 'advanced' : 'basic',
                Customfield2: ((stageNumber.length > 0 || !isNaN(stageNumber)) && !(this.state.isMasterReport)) ? `[${el.columnName+'00'+stageNumber}]`: el.columnName,
                Customfield1: el.columnType,
                Createdby : el.Createdby || this.props.loggedUserDetail.empID,
                Createdon : el.Createdon || new Date() ,
                Updatedby : el.Updatedby || this.props.loggedUserDetail.empID,
                Updatedon : el.Updatedon || new Date() ,
                CompanyId :  this.props.loggedUserDetail.CompanyId, 
            }
            }
        )


        ReportSettingSummaryType = {
            Id: 12345678,
            ReportSettingsSummaryId : "00000000-0000-0000-0000-000000000000",
            ReportSettingsId : reloadedreportSettings.ReportSetingsId || "00000000-0000-0000-0000-000000000000",
            SummaryName : 'null' ,
            Count : true ,
            Sum : true ,
            Average : true ,
            MaxValue : true ,
            MinValue : true ,
            Createdby : this.props.loggedUserDetail.empID,
            Createdon : new Date() ,
            Updatedby : this.props.loggedUserDetail.empID,
            Updatedon : new Date() ,
            CompanyId :  this.props.loggedUserDetail.CompanyId, 
        }

        ReportSettingsOrderbyListRun = orderBy.map((el) => {
            return{
                ReportSettingOrderby: "00000000-0000-0000-0000-000000000000",
                ReportSettingId: reloadedreportSettings.reportSetingsId || "00000000-0000-0000-0000-000000000000",
                OrderbyColumn:`${el.columnName}`,
                OrderSequence:`${el.sequence}`,
                // OrderbyColumn:`${el.columnName}`,
                // OrderSequence:`${el.sequence}`,
                Createdby : this.props.loggedUserDetail.empID,
                Createdon : new Date() ,
                Updatedby : this.props.loggedUserDetail.empID,
                Updatedon : new Date() ,
                CompanyId:this.props.loggedUserDetail.CompanyId,
                Customfield1: `${el.columnValue}`,
                Customfield2: `null`,
                Customfield3: `null`,
                Customfield4: `null`,
            }
        })


        let finalData = {
            ReportSettings,
            // ReportSettingsAdvanceFilterListrun,
            ReportSettingSummaryType,
            ReportSettingsOrderbyListRun 
        }

        this.setState({ loading: true });
        var dd = JSON.stringify(finalData);
        var datas = { key: dd };
        console.log("RunReport payload:", datas);

        axios.post(`/master/api/RunReport`, JSON.stringify(datas))
        .then(response => {
            
            if (response && response.status === 200) {
                let reportData = response.data;
                console.log("RunReport response:", reportData);
                if(reportData.Table.length > 0){
                    this.setState({reportData}); 
                    setTimeout(()=>{
                        this.processReportDataForPrinting(this.state.reportType);
                    },500)
                } else {
                    this.setState({ loading: false });
                    this.growl.show({ severity: 'error', summary: null, detail: 'No Data Available for the set filter conditions' });
                }
            }
            
        })
        .catch(err => {
            console.log("RunReport error:", err.response ? err.response.data : err);
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'Run Report Failed' });
        })

    }

    processReportDataForPrinting(data) {
        let {reportData } = this.state;
       
        let reportType = data
        let tabularReportSelected = false;
        let summaryReportSelected = false;
        if(reportType.length > 0){
            if (reportType.includes(1) || reportType.includes('1')){
                tabularReportSelected = true;
            } 
            if (reportType.includes(2)|| reportType.includes('2')){
                summaryReportSelected = true;
            }
        }

        let reportHeaders = [];
        let reportRows = [];
        let reportSummaryHeaders = [];
        let reportSummaryRows = [];
        let stageField = this.state.stageFieldCopy;
        
        if(tabularReportSelected) {
            reportHeaders = reportData && Object.keys(reportData.Table[0]) || [];
            // reportHeaders = this.state.selectedFilters.map((el) => {
            //     let headerValue = el.value;
            //     let reportField = stageField.find(el => el.stageFieldID == headerValue);
            //     return reportField.updatedBy;
            // }) || []
            reportRows = reportData && reportData.Table || [];
        }
        if(summaryReportSelected){
            reportSummaryHeaders = reportData && Object.keys(reportData.Table1[0]) || [];
            // reportSummaryHeaders = this.state.displaySummaryColumns.map((el) => {
            //     let headerValue = el.value;
            //     let reportField = stageField.find(el => el.stageFieldID == headerValue);
            //     return reportField.updatedBy;
            // }) || []
            reportSummaryRows = reportData && reportData.Table1 || [];
        }

        this.setState({loading: false, reportHeaders,reportRows, reportGenerated: true, reportSummaryHeaders, reportSummaryRows, reportGeneratedOn: moment(), reportGlobalSearchTerm: '', reportSearchColumn: null, reportColumnSearchValue: ''});
    }

    completeReset = () => {
        this.columnsReset();
        this.basicFilterFieldsReset();
        this.advancedFilterFieldsReset();
        this.orderByFieldsReset()
    }

    columnsReset = () => {
        this.setState({
            stageField: [],
            selectedFilters: [],
            basicAddedFilters: [],
            filters: [],
            availableSummaryColumns: [],
            displaySummaryColumns: [],
            orderBy:[],
        })
    }

    filterColumnsReset = () => {
        this.setState({
            basicAddedFilters: [],
            filters: [],
        })
    }

    summaryColumnReset = () => {
        this.setState({
            displaySummaryColumns:[],
        })
    }

    basicFilterFieldsReset= () => {
        this.setState({
            basicFilterIndex: this.state.index,
            basicColumnFilter: null,
            basicFieldName: '',
            basicFieldValidation: '',
            basicOperatorFilter: null,
            basicValueFilter: '',
            from: null,
            to: null,
            basicInclusiveOrExclusive: 'inclusive',
            basicNesting: 'N/A',
            basicConditionCombiner: 'and',
        })
    }

    orderByFieldsReset = () => {
        this.setState({
            orderByColumn:null,
            orderBySequence:null,
        })
    }

    advancedFilterFieldsReset= () => {
        this.setState({
            index: this.state.index,
            columnFilter: null,
            fieldName: '',
            fieldValidation: '',
            operatorFilter: null,
            valueFilter: '',
            from: null,
            to: null,
            inclusiveOrExclusive: 'inclusive',
            nesting: 'N/A',
            conditionCombiner: 'and',
        })
    }

    summaryFieldsReset = () => {
        this.setState({
            groupByAggregateColumn:[],
            groupByColumnValues:[],
            groupByFunction:[],
        });
    }

    getStageField (e) {
        this.setState({ loading: true, processValue: e.target.value });
        this.completeReset();
        let {type} = this.state; 
        axios.get(`/master/api/GetStageField?processId=${e.target.value}`)
            .then(response => {
                if (response && response.status === 200) {
                    let stageFieldCopy = response && response.data && response.data.map(el => el) || [];
                    let stageField = response && response.data && response.data.map(s => Object.assign({}, { label: s.updatedBy, value: s.stageFieldID, stageNum: s.stageName, filterType:(s.stageName.length == 0) ? 'basic' : 'advanced', toSendToBckend:s.fieldDescription}))|| [];
                    if (type == 'edit'){
                        this.completeReset();
                        setTimeout(() => {
                            this.setState({ stageField, stageFieldCopy, loading: false });
                        }, 300);
                    } else{
                        this.setState({ stageField, stageFieldCopy, loading: false });
                    }
                }
                
            })
            .catch(err => {
                this.setState({ error: 'TA Request Number Api Error', stageField: [], loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: 'Stage Field API Error' });
            })
    }

    downloadReportAsXls() {
        let {reportData } = this.state;
        let reportColumnNames = reportData && Object.keys(reportData.Table[0]);
    }
    //----------------run-report-functions-end---------------------

    renderBasicFilterOptionsPanel = () => {
        let dynamicKeyfilter = 'false';
        if(this.state.operatorType == 'int'){
            dynamicKeyfilter = 'int';
        } else if(this.state.operatorType == 'dec') {
            dynamicKeyfilter = 'num';
        }
        return (
            <Panel header="Basic Filter Options" toggleable={true}>

                <div className="p-grid p-justify-start">



                    {(this.state && this.state.basicAddedFilters &&  this.state.basicAddedFilters.length == 0) ?
                            null
                        :
                        <>
                            <div className="p-col-12" style={{marginTop:'2em'}}>
                                <DataTable  value={this.state.basicAddedFilters} ddd={"basic"} {...DATATABLE_CONFIG} >
                                    <Column field="column" header="Column" body={this.renderColumn}/>
                                    <Column field="operator" header="Operator"  body = {this.renderOperator}/>
                                    <Column field="value" header="Value" body={this.renderValue}/>
                                    {/* <Column field="inclusiveOrExclusive" header="Inclusive / Exclusive" /> TO BE UNCOMMENTED ONCE IMPLEMENTED IN BACKEND */}
                                    {/* <Column field="nestingValue" header="Nesting Options" /> TO BE UNCOMMENTED ONCE IMPLEMENTED IN BACKEND*/}
                                    <Column field="logicalOperator" header="Combiners" />
                                    {(!this.state.startedEditingBasicFilter) &&
                                    <Column body={this.basicActionTemplate} header="Action" />}
                                </DataTable>
                            </div>
                        </>
                    }


                    <div className="p-col">
                        <div className="p-col-12">
                            <label className="labeltop" htmlFor="input">Column</label>
                        </div>
                        <div className="p-col-12 ">
                            <Dropdown placeholder="Select Basic Column" name="basicColumnFilter" value={this.state.basicColumnFilter} options={this.state.basicFilters || []} onChange={this.changeData} {...DROPDOWN_CONFIG} className="p-col-12"  />
                        </div>
                    </div>

                    <div className="p-col">
                        <div className="p-col-12">
                            <label className="labeltop" htmlFor="input">Operator</label>
                        </div>
                        <div className="p-col-12 ">
                            <Dropdown placeholder="Select Operator" name="basicOperatorFilter" value={this.state.basicOperatorFilter} options={this.state.basicOperators} onChange={this.changeData} className="p-col-12"  />
                        </div>
                    </div>

                    {(this.state. basicOperatorType == 'guid' || this.state. basicOperatorType == 'nstring') ?
                        <div className="p-col">
                            <div className="p-col-12">
                                <label className="labeltop" htmlFor="input">Value</label>
                            </div>
                            <div className="p-col-12 ">
                                <MultiSelect placeholder="Select Value" name="basicValueFilter" value={this.state.basicValueFilter} options={this.state.basicMultiSelectOptions} onChange={this.changeData} className="p-col-12" {...DROPDOWN_CONFIG} />
                            </div>
                        </div>
                        :
                        null
                    }

                    {this.state.basicOperatorType == 'date' ?
                        <div className="p-col">
                            <div className="p-col-12">
                                <label className="labeltop" htmlFor="input">Value</label>
                            </div>
                            <div className="p-col-12 ">
                            <Calendar placeholder="Choose Date" value={this.state.basicValueFilter} name='basicValueFilter'  onChange={this.changeData} {...CALENDAR_CONFIG}/>
                            </div>
                        </div>
                    :
                        null
                    }

                    {(this.state. basicOperatorType == 'string' || this.state. basicOperatorType == 'int' || this.state. basicOperatorType == 'dec' || this.state. basicOperatorType == 'null') ?
                    <>
                        <div className="p-col">
                        <div className="p-col-12">
                            <label className="labeltop" htmlFor="input">Value</label>
                        </div>
                        <div className="p-col-12 ">
                            <InputText
                            placeholder="Enter Value"
                            name="basicValueFilter"
                            value={this.state.basicValueFilter}
                            onChange={this.changeData}
                            className="width100"
                            keyfilter={dynamicKeyfilter}
                            />
                        </div>
                    </div>
                    </> : null
                    }

                    {(this.state. basicOperatorType == 'bit' ) ?
                        <div className="p-col-2">
                            <div className="p-col">
                                <label className="labeltop" htmlFor="input">Value</label>
                            </div>
                            <div className="p-col-12 ">
                                <Dropdown placeholder="Select Value" name="basicValueFilter" value={this.state.basicValueFilter} options={this.state.bitOptions} onChange={this.changeData} className="p-col-12" {...DROPDOWN_CONFIG} />
                            </div>
                        </div>
                        :
                        null
                    }

                    {(this.state.currentSelectedBasicFilter == null) ?
                        <div className="p-col">
                            <div className="p-col-12">
                            </div>
                            <div className="p-col-12">
                            <Button  type="button" label="Add" icon="pi pi-plus" className="p-button-success p-button-rounded" onClick={() => this.manageFilterAddition('basicFilter')} />
                            </div>
                        </div>
                        :
                        <div className="p-col">
                            <div className="p-col-12">
                            </div>
                            <div className="p-col-12">
                            <Button type="button" label="Update" icon="pi pi-plus" className="p-button-warning p-button-rounded" onClick= {() => this.handleUpdateItem('basicFilter')} />
                            </div>
                            <div className="p-col-12">
                            <Button type="button" label="Cancel" className="p-button-success p-button-rounded" onClick={() => this.handleCancelEditItem('basicFilter')} />
                            </div>
                        </div>

                    }



                </div>
            </Panel>
        );
    }

    renderAdvancedFilterOptionsPanel = () => {
        let dynamicKeyfilter = 'false';
        if(this.state.operatorType == 'int'){
            dynamicKeyfilter = 'int';
        } else if(this.state.operatorType == 'dec') {
            dynamicKeyfilter = 'num';
        }
        return (
            <Panel header="Advanced Filter Options" toggleable={true}>

                <div className="p-grid p-justify-start">



                    {(this.state && this.state.filters &&  this.state.filters.length == 0) ?
                            null
                        :
                        <>
                            <div className="p-col-12" style={{marginTop:'2em'}}>
                                <DataTable  value={this.state.filters} {...DATATABLE_CONFIG} >
                                    <Column field="column" header="Column" body={this.renderColumn}/>
                                    <Column field="operator" header="Operator" body={this.renderOperator}/>
                                    <Column field="value" header="Value" body={this.renderValue}/>
                                    {/* <Column field="inclusiveOrExclusive" header="Inclusive / Exclusive" />
                                    <Column field="nestingValue" header="Nesting Options" /> TO BE UNCOMMENTED ONCE IMPLEMENTED IN BACKEND */}
                                    <Column field="logicalOperator" header="Combiners" />
                                    {(!this.state.startedEditingAdvanceFilter) && <Column body={this.advancedActionTemplate} header="Action" />}
                                </DataTable>
                            </div>
                        </>
                    }

                    <div className="p-col">
                        <div className="p-col-12">
                            <label className="labeltop" htmlFor="input">Column</label>
                        </div>
                        <div className="p-col-12 ">
                            <Dropdown placeholder="Select Column" name="columnFilter" value={this.state.columnFilter} options={this.state.advancedFilters || []} onChange={this.changeData} {...DROPDOWN_CONFIG} className="p-col-12"  />
                        </div>
                    </div>

                    <div className="p-col">
                        <div className="p-col-12">
                            <label className="labeltop" htmlFor="input">Operator</label>
                        </div>
                        <div className="p-col-12 ">
                            <Dropdown placeholder="Select Operator" name="operatorFilter" value={this.state.operatorFilter} options={this.state.operators} onChange={this.changeData} className="p-col-12"  />
                        </div>
                    </div>

                    {(this.state.operatorType == 'guid' || this.state.operatorType == 'nstring') ?
                        <div className="p-col">
                            <div className="p-col-12">
                                <label className="labeltop" htmlFor="input">Value</label>
                            </div>
                            <div className="p-col-12 ">
                                <MultiSelect placeholder="Select Value" name="valueFilter" value={this.state.valueFilter} options={this.state.multiSelectOptions} onChange={this.changeData} className="p-col-12" {...DROPDOWN_CONFIG} />
                            </div>
                        </div>
                        :
                        null
                    }

                    {this.state.operatorType == 'date' ?
                        <div className="p-col">
                            <div className="p-col-12">
                                <label className="labeltop" htmlFor="input">Value</label>
                            </div>
                            <div className="p-col-12 ">
                            <Calendar placeholder="Choose Date" value={this.state.valueFilter} name='valueFilter'  onChange={this.changeData} {...CALENDAR_CONFIG}/>
                            </div>
                        </div>
                    :
                        null
                    }

                    {(this.state.operatorType == 'string' || this.state.operatorType == 'int' || this.state.operatorType == 'dec' || this.state.operatorType == 'null') ?
                    <>
                        <div className="p-col">
                        <div className="p-col-12">
                            <label className="labeltop" htmlFor="input">Value</label>
                        </div>
                        <div className="p-col-12 ">
                            <InputText
                            placeholder="Enter Value"
                            name="valueFilter"
                            value={this.state.valueFilter}
                            onChange={this.changeData}
                            className="width100"
                            keyfilter={dynamicKeyfilter}
                            />
                        </div>
                    </div>
                    </> : null
                    }

                    {(this.state.operatorType == 'bit' ) ?
                        <div className="p-col-2">
                            <div className="p-col">
                                <label className="labeltop" htmlFor="input">Value</label>
                            </div>
                            <div className="p-col-12 ">
                                <Dropdown placeholder="Select Value" name="valueFilter" value={this.state.valueFilter} options={this.state.bitOptions} onChange={this.changeData} className="p-col-12" {...DROPDOWN_CONFIG} />
                            </div>
                        </div>
                        :
                        null
                    }

                    {(this.state.currentSelectedFilter == null) ?
                        <div className="p-col">
                            <div className="p-col-12">
                            </div>
                            <div className="p-col-12">
                            <Button  type="button" label="Add" icon="pi pi-plus" className="p-button-success p-button-rounded" onClick={() => this.manageFilterAddition('advancedFilter')} />
                            </div>
                        </div>
                        :
                        <div className="p-col">
                            <div className="p-col-12">
                            </div>
                            <div className="p-col-12">
                            <Button type="button" label="Update" icon="pi pi-plus" className="p-button-warning p-button-rounded" onClick= {() => this.handleUpdateItem('advancedFilter')} />
                            </div>
                            <div className="p-col-12">
                            <Button type="button" label="Cancel" className="p-button-success p-button-rounded" onClick={() => this.handleCancelEditItem('advancedFilter')} />
                            </div>
                        </div>

                    }



                </div>
            </Panel>
        );
    }




    render() {
        if(this.props.success){
            REDIRECT_TO_URL('/reports-setting/',this.props);
        }
        let isTabularReportSelected = false;
        let isSummaryReportSelected = false;
        if(this.state.reportType.length > 0){
            if (this.state.reportType.includes(1) || this.state.reportType.includes('1')){
                isTabularReportSelected = true;
            } 
            if (this.state.reportType.includes(2)|| this.state.reportType.includes('2')){
                isSummaryReportSelected = true;
            }
        }

        const { stageField = [] } = this.state;
        const PatternData = stageField.map(s => Object.assign({}, { label: s.fieldDescription, value: s.stageFieldID, stageNum: s.stageName}))

         let storageItems = [];

        if(this.props.tableLists !== undefined){
            storageItems = this.props.tableLists;
        }

        let isDisabled = false;
        if(this.state.type == 'view'){
            isDisabled = true
        }
        let reportHeaders = (this.state && this.state.reportHeaders) || [] ;
        let reportSummaryHeaders = (this.state && this.state.reportSummaryHeaders) || [] ;

        let rawReportRows = (this.state && this.state.reportRows) || [];
        let rawReportSummaryRows = (this.state && this.state.reportSummaryRows) || [];

        let reportRows = this.applyReportQuickSearch(this.applyReportFilterConditions(rawReportRows)).map(element => Object.values(element));
        let reportSummaryRows = this.applyReportQuickSearch(this.applyReportFilterConditions(rawReportSummaryRows)).map(element => Object.values(element));

        const type = this.props.match.params.type;




        const ref = React.createRef();
        const logoRef = React.createRef();

        const DownloadDataAsHtml = ({ style }) => {
            let filters = this.state.filters || [];
            let stageFieldCopy = this.state.stageFieldCopy || [];
            let stageFieldID = this.state.groupByAggregateColumn || [];
            let groupByColumnValues = this.state.groupByColumnValues || [];
            let gacLabel = stageFieldCopy && stageFieldCopy.filter(el => el.stageFieldID == stageFieldID).map(el => el.fieldDescription + ',') || [];
            let groupByColumnLabels = stageFieldCopy && stageFieldCopy.filter(el => groupByColumnValues.includes(el.stageFieldID)).map(el => el.fieldDescription + ', ') || [];

            let tabularReportSelected = false;
            let summaryReportSelected = false;
            if(this.state.reportType.length > 0){
                if (this.state.reportType.includes(1) || this.state.reportType.includes('1')){
                    tabularReportSelected = true;
                } 
                if (this.state.reportType.includes(2)|| this.state.reportType.includes('2')){
                    summaryReportSelected = true;
                }
            }
            let reportGeneratedOn = this.state.reportGeneratedOn || moment();
            let reportRecordCount = tabularReportSelected ? reportRows.length : reportSummaryRows.length;

            const handleDownloadReportAsPdf = () => {
                let doc = new jsPDF('l', 'mm', 'a4');
                let pageWidth = doc.internal.pageSize.getWidth();
                let pageHeight = doc.internal.pageSize.getHeight();
                let marginLeft = 10;
                let marginRight = 10;
                let reportTitle = (this.state.reloadedreportSettings && this.state.reloadedreportSettings.reportName) || this.state.reportName || 'Report';
                let requestedBy = `${(this.props.loggedUserDetail && this.props.loggedUserDetail.userName) || ''}${(this.props.loggedUserDetail && this.props.loggedUserDetail.userID) ? ' (' + this.props.loggedUserDetail.userID + ')' : ''}`;
                let requestDateText = reportGeneratedOn.format('MMMM Do YYYY, h:mm:ss a');
                let filterConditionText = this.getReportAppliedConditionsSummary();
                let searchConditionText = this.getReportSearchAppliedSummary();

                if(logoRef.current){
                    try {
                        doc.addImage(logoRef.current, 'PNG', marginLeft, 8, 32, 14);
                    } catch(e) {
                        // logo could not be embedded, continue without it
                    }
                }

                doc.setFont('helvetica');
                doc.setFontStyle('bold');
                doc.setFontSize(15);
                doc.text(reportTitle, pageWidth / 2, 14, { align: 'center' });

                doc.setFontStyle('normal');
                doc.setFontSize(9);
                doc.text(`Requested By: ${requestedBy}`, pageWidth - marginRight, 10, { align: 'right' });
                doc.text(`Request Date: ${requestDateText}`, pageWidth - marginRight, 15, { align: 'right' });

                let contentWidth = pageWidth - marginLeft - marginRight - 4;
                let filterLines = doc.splitTextToSize(`Filter : ${filterConditionText}`, contentWidth);
                let searchLines = doc.splitTextToSize(`Search : ${searchConditionText}`, contentWidth);

                doc.text('Condition Applied :', marginLeft, 26);
                doc.text(filterLines, marginLeft + 4, 30);
                let searchY = 30 + (filterLines.length * 4) + 2;
                doc.text(searchLines, marginLeft + 4, searchY);

                let drawFooter = () => {
                    doc.setFontSize(8);
                    doc.setFontStyle('normal');
                    doc.text(`Total Records: ${reportRecordCount}`, marginLeft, pageHeight - 8);
                    doc.text(`Report Generated On: ${requestDateText}`, pageWidth - marginRight, pageHeight - 8, { align: 'right' });
                };

                let startY = searchY + (searchLines.length * 4) + 4;

                if(tabularReportSelected && reportHeaders.length > 0){
                    doc.autoTable({
                        head: [reportHeaders],
                        body: reportRows,
                        startY,
                        margin: { left: marginLeft, right: marginRight, bottom: 14 },
                        styles: { fontSize: 8 },
                        headStyles: { fillColor: [200, 215, 242], textColor: 20 },
                        didDrawPage: drawFooter,
                    });
                    startY = doc.lastAutoTable.finalY + 10;
                }

                if(summaryReportSelected && reportSummaryHeaders.length > 0){
                    if(tabularReportSelected){
                        doc.setFontSize(11);
                        doc.setFontStyle('bold');
                        doc.text('Summary Report', marginLeft, startY);
                        startY += 6;
                    }
                    doc.autoTable({
                        head: [reportSummaryHeaders],
                        body: reportSummaryRows,
                        startY,
                        margin: { left: marginLeft, right: marginRight, bottom: 14 },
                        styles: { fontSize: 8 },
                        headStyles: { fillColor: [200, 215, 242], textColor: 20 },
                        didDrawPage: drawFooter,
                    });
                }

                let fileName = reportTitle.replace(/[^a-z0-9]+/gi, '_');
                doc.save(`${fileName}.pdf`);
            };

            return(
            <div className="p-grid" style={style}>
                <div className="mt1">
                    <div className="report-meta-header" style={{ border: 'solid 1px black', padding: '10px 15px', marginBottom: '10px', backgroundColor: '#f4f6fb' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <img ref={logoRef} src={ChendhurLogo} alt="Company Logo" style={{ maxHeight: '55px', maxWidth: '160px' }} />
                            <div style={{ flex: 1, textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
                                {(this.state.reloadedreportSettings && this.state.reloadedreportSettings.reportName) || this.state.reportName || 'Report'}
                            </div>
                            <div style={{ textAlign: 'right', fontSize: '13px' }}>
                                <div><strong>{'Requested By: '}</strong>{`${(this.props.loggedUserDetail && this.props.loggedUserDetail.userName) || ''}${(this.props.loggedUserDetail && this.props.loggedUserDetail.userID) ? ' (' + this.props.loggedUserDetail.userID + ')' : ''}`}</div>
                                <div><strong>{'Request Date: '}</strong>{reportGeneratedOn.format('MMMM Do YYYY, h:mm:ss a')}</div>
                            </div>
                        </div>
                        <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: 'solid 1px #cfd6e4', fontSize: '13px' }}>
                            <div><strong>{'Condition Applied :'}</strong></div>
                            <div style={{ marginLeft: '1em' }}><strong>{'Filter : '}</strong>{this.getReportAppliedConditionsSummary()}</div>
                            <div style={{ marginLeft: '1em' }}><strong>{'Search : '}</strong>{this.getReportSearchAppliedSummary()}</div>
                        </div>
                    </div>
                    <div className="report-search-toolbar" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '1em', border: 'solid 1px black', borderTop: 'none', padding: '10px 15px', marginBottom: '10px' }}>
                        <div className="p-datatable-globalfilter-container">
                            <InputText
                                type="search"
                                value={this.state.reportGlobalSearchTerm}
                                onInput={(e) => this.setState({ reportGlobalSearchTerm: e.target.value })}
                                placeholder="Search all columns"
                            />
                        </div>
                        <Dropdown
                            placeholder="Search by column"
                            value={this.state.reportSearchColumn}
                            options={Array.from(new Set([...reportHeaders, ...reportSummaryHeaders])).map(header => ({ label: header, value: header }))}
                            onChange={(e) => this.setState({ reportSearchColumn: e.value })}
                            showClear
                            style={{ minWidth: '200px' }}
                            {...DROPDOWN_CONFIG}
                        />
                        <InputText
                            type="search"
                            value={this.state.reportColumnSearchValue}
                            onChange={(e) => this.setState({ reportColumnSearchValue: e.target.value })}
                            placeholder="Column value"
                            disabled={!this.state.reportSearchColumn}
                        />
                    </div>
                    <ReactHTMLTableToExcel
                        className="p-button p-component p-button-secondary table-xls-button"
                        table="table-to-xls"
                        filename="Report"
                        sheet="Report"
                        style={{ marginBottom: '10px' }}
                        buttonText={<div><span className="pi pi-download p-c p-button-icon-left" />Export Excel</div>} />
                    <Button
                        type="button"
                        className="p-button-secondary ml1"
                        style={{ marginBottom: '10px' }}
                        icon="pi pi-file-pdf"
                        label="Download PDF"
                        onClick={handleDownloadReportAsPdf}
                    />
                    <TableContainer component={Paper}>
                        <div style={{ height:'auto',width: '100%', overflowX: 'auto' }}>
                        <Table aria-label="spanning table" id="table-to-xls" ref={ref} >
                                    <TableHead className="payslipHeader">
                                        {tabularReportSelected && <TableRow>
                                            <TableCell align="center" colSpan= {`${Math.max(reportHeaders.length, 1)}`} style={{ backgroundColor: '#c8d7f2', border: "solid 1px black", fontSize:'22px', fontWeight: 'bold' }}>
                                                {(this.state.reloadedreportSettings && this.state.reloadedreportSettings.reportName) || this.state.reportName || 'REPORT'}
                                            </TableCell>
                                        </TableRow>}

                                        {tabularReportSelected && <TableRow>
                                            {reportHeaders && reportHeaders.map(el => {
                                                return(
                                                    <TableCell align="center" colSpan= '1 ' style={{border: "solid 1px black", fontSize:'20px' }}>{el}</TableCell >
                                                )
                                            })}
                                        </TableRow>}
                                    </TableHead>
                                    <TableBody className="payslipBody">
                                        {reportRows.map(row => {
                                            return(
                                                <TableRow style={{ backgroundColor: 'white', border: "solid 1px black" }}>
                                                    {
                                                        row.map(element => <TableCell style={{textAlign: 'center', fontSize:'15px'}} align="center" colSpan= '1'>{element}</TableCell>
                                                        )
                                                    }
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                    {/* {tabularReportSelected ? <TableBody> uncomment for tabular report constraints
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" colSpan= '6 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Tabular Report Constraints</TableCell >
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Column</TableCell >
                                                <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Operator</TableCell >
                                                <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Value</TableCell >
                                                {/* <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Inclusive/Exclusive</TableCell > TO BE UNCOMMENTED ONCE IMPLEMENTED IN BACKEND
                                                <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Combiners</TableCell >
                                                 <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Nesting options</TableCell > TO BE UNCOMMENTED ONCE IMPLEMENTED IN BACKEND 
                                            </TableRow>
                                        </TableHead>
                                            <TableBody>
                                            {
                                                filters.map(filter => {
                                                    return(
                                                        <TableRow>
                                                            <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{filter.columnName}</TableCell>
                                                            <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{filter.operator}</TableCell>
                                                            <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{filter.label}</TableCell>
                                                            {/* <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{filter.inclusiveOrExclusive}</TableCell> TO BE UNCOMMENTED ONCE IMPLEMENTED IN BACKEND 
                                                            {/* <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{filter.nestingValue}</TableCell> TO BE UNCOMMENTED ONCE IMPLEMENTED IN BACKEND 
                                                            <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{filter.logicalOperator}</TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            }
                                                <TableRow></TableRow>
                                            </TableBody>
                                    </TableBody> : null} */}

                                    {summaryReportSelected ? <TableHead className="payslipHeader">
                                        <TableRow></TableRow>
                                
                                        {/* <TableCell align="center" colSpan= {`${reportSummaryHeaders.length}`} style={{ backgroundColor: '#c8d7f2', border: "solid 1px black", fontSize:'25px' }} rowSpan = '2'>
                                            {'Summary Report'}
                                        </TableCell> */}

                                        <TableRow></TableRow> 

                                        <TableRow>
                                            {reportSummaryHeaders && reportSummaryHeaders.map(el => {
                                                return(
                                                    <TableCell align="center" colSpan= '1 ' style={{ border: "solid 1px black", fontSize:'20px' }}>{el}</TableCell >
                                                )
                                            })}
                                        </TableRow>

                                    </TableHead> : null}

                                    {summaryReportSelected ? <TableBody className="payslipBody">
                                        {reportSummaryRows.map(row => {
                                            return(
                                                <TableRow style={{ backgroundColor: 'white', border: "solid 1px black" }}>
                                                    {
                                                        row.map(element => <TableCell style={{textAlign: 'center', fontSize:'15px'}} align="center" colSpan= '1'>{element}</TableCell>
                                                        )
                                                    }
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody> : null}

                                    {/* {summaryReportSelected ? <TableBody>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" colSpan= '3 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Summary Report Constraints</TableCell >
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Group By Aggregate Column</TableCell >
                                                <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Group By Column</TableCell >
                                                <TableCell align="center" colSpan= '1 ' style={{ backgroundColor: '#c8d7f2', border: "solid 1px black" }}>Group By Function</TableCell >
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>                                        
                                            <TableRow>
                                                <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{gacLabel || ''}</TableCell>
                                                <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{groupByColumnLabels}</TableCell>
                                                <TableCell align="center" colSpan= '1' style={{ backgroundColor: '#bdbbbb', border: "solid 1px black", textAlign: 'center' }}>{this.state.groupByFunction}</TableCell>
                                            </TableRow>                                                
                                            <TableRow></TableRow>
                                        </TableBody>
                                    </TableBody> : null} */}


                                </Table>
                        </div>
                    </TableContainer>
                    <div className="report-meta-footer" style={{ display: 'flex', justifyContent: 'space-between', border: 'solid 1px black', borderTop: 'none', padding: '8px 15px', fontSize: '12px', backgroundColor: '#f4f6fb' }}>
                        <span>{`Total Records: ${reportRecordCount}`}</span>
                        <span>{`Report Generated On: ${reportGeneratedOn.format('MMMM Do YYYY, h:mm:ss a')}`}</span>
                    </div>
                </div>
            </div>)}





        return (


            <div className="p-col-12 treewidth padding">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />

                <div className="card card-w-title">
                    <h1>Reports Setting</h1>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12 p-md-12">
                            <Panel header="Header" toggleable={true}>
                                <div className="p-grid">

                                    <div className="p-col-12 p-md-4" style={{ textAlign: 'right' }}>
                                        <label htmlFor="input">Report Name <span className="requiredColor">*</span></label>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <InputText disabled = {isDisabled} name='reportName' onChange={this.changeData} value= {this.state.reportName} className="width100" />
                                    </div>
                                    
                                    <div className="p-col-12 p-md-4" style={{ textAlign: 'right' }}>
                                        <label htmlFor="input">Process</label>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <Dropdown disabled = {isDisabled} className="width100" options={this.state.processOptions} value={this.state.processValue} placeholder="Select" onChange={this.getStageField.bind(this)} />
                                    </div>

                                    <div className="p-col-12 p-md-4" style={{ textAlign: 'right' }}>
                                        <label htmlFor="input">Report Type</label>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <SelectButton  value={this.state.reportType} options={this.state.reportTypeOptions} onChange={(e) => this.handleReportTypeChange(e)} optionLabel="name" multiple />
                                    </div>

                                </div>
                            </Panel>


                            <Panel header="Columns" toggleable={true}>

                                 {/* <div className="p-grid ListBox">
                                    <ul>
                                        <li>
                                            {this.state.processValue ? 
                                            <select id="select1" name="select1" multiple>
                                              {PatternData.map((p, l) => <option key={l} value={p.value}>{p.label}</option>)}
                                            </select> : 
                                            <select id="select1" name="select1" multiple>
                                            </select>}
                                        </li>
                                        {isDisabled ?
                                         null:
                                         <li class="relative">
                                            <input type="button" id="add" value="&#8702;" onClick={() => this.addOptions('select1', 'select2')} />
                                            <input type="button" id="remove" value="&#8701;" onClick={() => this.addOptions('select2', 'select1')} />
                                        </li>}
                                        <li>
                                            <select id="select2" name="select2" multiple></select>
                                        </li>
                                    </ul>
                                </div>  */}
                                <div className="p-grid p-justify-even">
                                   {(this.state.type && (this.state.type == 'add' || this.state.type == 'edit'))? 
                                   <>
                                    <div className="p-col">
                                        <div className="p-col-11">
                                            <DataTable
                                            value={this.state.stageField}
                                            responsive
                                            className="p-datatable-customers animated fadeIn"
                                            rowHover
                                            paginator
                                            rows={10}
                                            selection={this.state.selectedAvailableColumns}
                                            onSelectionChange={e => this.setState({ selectedAvailableColumns: e.value })}
                                            emptyMessage="No lists found"
                                            globalFilter={this.state.globalFilter}
                                            header={this.renderHeader('Available Column')} 
                                            {...DATATABLE_CONFIG}
                                            >

                                                <Column selectionMode="multiple" style={{ width: '3em' }} />
                                                <Column field="label" header="Field" />
                                                <Column field="stageNum" header="Stage Number" sortable={true}/>
                                                <Column field="filterType" header="Filter Type" sortable={true}/>
                                               
                                            </DataTable>
                                        </div>
                                        
                                    </div>

                                    <div className="p-grid p-align-center vertical-container p-justify-even">                                        
                                        <div className="p-col">
                                            <Button icon="pi pi-caret-left" onClick = {() =>{this.handleRemoveColumns('display')}}  />
                                        </div>     
                                        <div className="p-col">
                                            <Button icon="pi pi-caret-right" onClick = {() =>{this.handleAddColumns('available')}}  />
                                            
                                        </div>                                                                           
                                    </div>
                                    </> : null
                                    }

                                    
                                    <div className="p-col">
                                        <div className="p-col-12">
                                            <DataTable
                                            value={this.state.selectedFilters}
                                            responsive
                                            className="p-datatable-customers animated fadeIn"
                                            rowHover
                                            selection={this.state.selectedDisplayColumns}
                                            onSelectionChange={e => this.setState({ selectedDisplayColumns: e.value })}
                                            paginator
                                            rows={10}
                                            emptyMessage="No lists found"
                                            globalFilter={this.state.globalFilter}
                                            header={this.renderHeader('Display Columns')}
                                            {...DATATABLE_CONFIG}
                                             >
                                                {(this.state.type && (this.state.type == 'add' || this.state.type == 'edit'))? <Column selectionMode="multiple" style={{ width: '3em' }} />: null}
                                                <Column field="label" header="Field" />
                                                <Column field="stageNum" header="Stage Number" sortable={true}/>
                                                <Column field="filterType" header="Filter Type" sortable={true}/>
                                            </DataTable>
                                        </div>
                                    </div>                                    
                                </div>
                            </Panel>


                        {isTabularReportSelected &&
                        <Panel className="reportFilterSelction" header="Filter Options for Tabular Report" toggleable={true}>
                            {this.renderBasicFilterOptionsPanel()}
                            {this.renderAdvancedFilterOptionsPanel()}
                        </Panel>}


                            {isSummaryReportSelected && 
                            <Panel header="Report Summary" toggleable={true}>
                                <div className="p-grid p-justify-even">
                                    {(this.state.type && (this.state.type == 'add' || this.state.type == 'edit'))? 
                                    <>
                                        <div className="p-col">
                                            <div className="p-col-12">
                                                <DataTable
                                                value={this.state.availableSummaryColumns}
                                                responsive
                                                className="p-datatable-customers animated fadeIn"
                                                rowHover
                                                selection={this.state.selectedAvailableSummaryColumns}
                                                onSelectionChange={e => this.setState({ selectedAvailableSummaryColumns: e.value })}
                                                paginator
                                                rows={10}
                                                emptyMessage="No lists found"
                                                globalFilter={this.state.globalFilter}
                                                header={this.renderHeader('Available Summary Columns')}
                                                {...DATATABLE_CONFIG}
                                                >
                                                    {(this.state.type && (this.state.type == 'add' || this.state.type == 'edit'))? <Column selectionMode="multiple" style={{ width: '3em' }} />: null}
                                                    <Column field="label" header="Field" />
                                                    <Column field="stageNum" header="Stage Number" sortable={true}/>
                                                    <Column field="filterType" header="Filter Type" sortable={true}/>
                                                </DataTable>
                                            </div>
                                        </div>   

                                        <div className="p-grid p-align-center vertical-container p-justify-even">                                        
                                            <div className="p-col">
                                                <Button icon="pi pi-caret-left" onClick = {() =>{this.handleRemoveSummaryColumns('display')}}  />
                                            </div>     
                                            <div className="p-col">
                                                <Button icon="pi pi-caret-right" onClick = {() =>{this.handleAddSummaryColumn('available')}}  />
                                                
                                            </div>                                                                           
                                        </div>
                                        </> : null
                                        }                                
                                        <div className="p-col">
                                            <div className="p-col-12">
                                                <DataTable
                                                value={this.state.displaySummaryColumns}
                                                responsive
                                                className="p-datatable-customers animated fadeIn"
                                                rowHover
                                                selection={this.state.selectedDisplaySummaryColumns}
                                                onSelectionChange={e => this.setState({ selectedDisplaySummaryColumns: e.value })}
                                                paginator
                                                rows={10}
                                                emptyMessage="No lists found"
                                                globalFilter={this.state.globalFilter}
                                                header={this.renderHeader('Display Summary Columns')}
                                                {...DATATABLE_CONFIG}
                                                >
                                                    {(this.state.type && (this.state.type == 'add' || this.state.type == 'edit'))? <Column selectionMode="multiple" style={{ width: '3em' }} />: null}
                                                    <Column field="label" header="Field" />
                                                    <Column field="stageNum" header="Stage Number" sortable={true}/>
                                                    <Column field="filterType" header="Filter Type" sortable={true}/>
                                                </DataTable>
                                            </div>
                                        </div>                                    
                                    </div>


                                    <div className="p-grid p-justify-even">

                                        <div className="p-col">
                                            <div className="p-col-12">
                                                <label className="labeltop" htmlFor="input">Group By Aggregate Column</label>
                                            </div>
                                            <div className="p-col-12 ">
                                                <Dropdown placeholder="Group By Aggregate Column" name="groupByAggregateColumn" value={this.state.groupByAggregateColumn} options={this.state.displaySummaryColumns} onChange={this.changeData} {...DROPDOWN_CONFIG} className="p-col-12"  />
                                            </div>	
                                        </div> 

                                        <div className="p-col">
                                            <div className="p-col-12">
                                                <label className="labeltop" htmlFor="input">Group By Column</label>
                                            </div>
                                            <div className="p-col-12 ">
                                                <MultiSelect placeholder="Group By Column" name="groupByColumn" value={this.state.groupByColumnValues} options={this.state.groupByColumnOptions} onChange={this.changeData} className="p-col-12" {...DROPDOWN_CONFIG} />
                                            </div>	
                                        </div>

                                        <div className="p-col">
                                            <div className="p-col-12">
                                                <label className="labeltop" htmlFor="input">Group By Function</label>
                                            </div>
                                            <div className="p-col-12 ">
                                                <Dropdown placeholder="Group By Function" name="groupByFunction" value={this.state.groupByFunction} options={this.state.groupByFunctionOptions} onChange={this.changeData} {...DROPDOWN_CONFIG} className="p-col-12"  />
                                            </div>	
                                        </div> 

                                    </div>
                            </Panel>}

                            <Panel header="Order By" toggleable={true}>
                                <div className="p-grid p-justify-even">
                                    <div className="p-col">
                                        <div className="p-col-12">
                                            <DataTable
                                            value={this.state.orderBy}
                                            responsive
                                            className="p-datatable-customers animated fadeIn"
                                            rowHover
                                            paginator
                                            rows={10}
                                            emptyMessage="No lists found"
                                            globalFilter={this.state.globalFilter}
                                            header={this.renderHeader('Order By')}
                                            {...DATATABLE_CONFIG}
                                            >
                                                <Column field="columnName" header="Field" />
                                                <Column field="sequence" header="Order By Sequence" sortable={true}/>
                                                <Column field="filterType" header="Action" sortable={true}/>
                                                <Column body={this.orderByActionTemplate} header="Action" />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-grid p-justify-even">
                                    <div className="p-col">
                                        <div className="p-col-12">
                                            <label className="labeltop" htmlFor="input">Order By Column</label>
                                        </div>
                                        <div className="p-col-12 ">
                                            <Dropdown placeholder="Select Column" name="orderByColumn" value={this.state.orderByColumn} options={this.state.selectedFilters || []} onChange={this.changeData} {...DROPDOWN_CONFIG} className="p-col-12"  />
                                        </div>
                                    </div>

                                    <div className="p-col">
                                        <div className="p-col-12">
                                            <label className="labeltop" htmlFor="input">Order By Sequence</label>
                                        </div>
                                        <div className="p-col-12 ">
                                            <Dropdown placeholder="Order By Sequence" name="orderBySequence" value={this.state.orderBySequence} options={this.state.orderBySequenceOption} onChange={this.changeData} {...DROPDOWN_CONFIG} className="p-col-12"  />
                                        </div>	
                                    </div> 

                                    <div className="p-col">
                                        <div className="p-col-12">                                   
                                        </div>
                                        <div className="p-col-12">
                                        <Button  type="button" label="Order" icon="pi pi-plus" className="p-button-success p-button-rounded" onClick={() => this.handleOrderByAddition('advancedFilter')} />
                                        </div>
                                    </div>

                                </div>

                                
                            </Panel>


                            <Panel header="Actions" toggleable={true}>
                                <div className="p-grid p-justify-start	">
                                        {(type == 'add' && type !== 'view')? <Button  label="Save Report Setting" className="p-button-success ml1"  onClick={() => this.saveReport('save')} /> : null
                                        }
                                        {(type == 'edit' && type !== 'add' && type !== 'view')? <Button  label="Update Report Setting" className="p-button-success ml1"  onClick={() => this.saveReport('edit')} /> : null
                                        }
                                        {(type == 'edit' && type !== 'add' && type !== 'view')? <Button  label="Cancel" className="p-button-success ml1"  onClick={() => this.props.history.push('/reports-setting')} /> : null
                                        }
                                        {(type != 'add' && type == 'view') ? <Button  label="Run Report" className="p-button-success ml1"  onClick={() => this.runReport()} /> : null}
                                        {(this.state.reportGenerated == true && (type != 'add' && type == 'view'))?
                                        <Button  label="View Data" className="p-button-success ml1"  onClick={() => this.setState({reportDataDisplay:true})} /> 
                                        :
                                        null}
                                        {(this.state.reportGenerated == true && (type != 'add' && type == 'view'))?
                                        <ReactHTMLTableToExcel
                                        className="p-button p-component p-button-secondary ml1"
                                        table="table-to-xls"
                                        filename="Report"
                                        sheet="Report"
                                        buttonText={<div><span className="pi pi-download p-c p-button-icon-left" />Export Data As Excel</div>} /> 
                                        : 
                                        null}
                                        {/* <Button  label="Download Data As Excel" className="p-button-success ml1"  onClick={() => this.downloadReportAsXls()} /> */}
                                </div>
                            </Panel>
                            {!this.state.reportDataDisplay ? DownloadDataAsHtml({ style: { display: 'none' } }) : null}
                            <Dialog dismissableMask = { true }  header="View Report" className="dialogflex" style={{ width: '85vw', maxWidth: '1200px' }} maximizable={true} visible={this.state.reportDataDisplay} modal={true} onHide={() => this.setState({ reportDataDisplay: false, reportGlobalSearchTerm: '', reportSearchColumn: null, reportColumnSearchValue: ''})}>
                                {isTabularReportSelected &&
                                    <Panel header="Filter Options" toggleable={true} collapsed={true} className="reportFilterSelction">
                                        {this.renderBasicFilterOptionsPanel()}
                                        {this.renderAdvancedFilterOptionsPanel()}
                                    </Panel>
                                }
                                {DownloadDataAsHtml({})}
                            </Dialog>
                            
                                
                                        
                                 
                           

                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success:state.master.success,
        tableLists : state.master.tableLists,
        GetEmployeedropdown : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        OrgType : (state.keyword.OrgType!==undefined) ? state.keyword.OrgType : [],
        positionList : state.master.positionList,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchPositionLists : () => dispatch(actions.fetchPositionLists()),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(ReportsSetting);